/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createUser = /* GraphQL */ `mutation CreateUser(
  $input: CreateUserInput!
  $condition: ModelUserConditionInput
) {
  createUser(input: $input, condition: $condition) {
    id
    cognitoSubId
    tenantId
    email
    givenName
    phoneNumber
    familyName
    meetingId
    defaultFiltersCustomValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    lockedFiltersCustomValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    defaultFilterValues {
      key
      values
      __typename
    }
    lockedFilters {
      key
      values
      __typename
    }
    shareBCC
    shareCC
    createdAt
    createdBy
    updatedAt
    status
    role
    bookmarkedDocs {
      docID
      createdAt
      __typename
    }
    bookmarkedFolders {
      folderID
      createdAt
      __typename
    }
    isExcludedFromReporting
    additionalRoles
    altUsername
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserMutationVariables,
  APITypes.CreateUserMutation
>;
export const updateUser = /* GraphQL */ `mutation UpdateUser(
  $input: UpdateUserInput!
  $condition: ModelUserConditionInput
) {
  updateUser(input: $input, condition: $condition) {
    id
    cognitoSubId
    tenantId
    email
    givenName
    phoneNumber
    familyName
    meetingId
    defaultFiltersCustomValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    lockedFiltersCustomValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    defaultFilterValues {
      key
      values
      __typename
    }
    lockedFilters {
      key
      values
      __typename
    }
    shareBCC
    shareCC
    createdAt
    createdBy
    updatedAt
    status
    role
    bookmarkedDocs {
      docID
      createdAt
      __typename
    }
    bookmarkedFolders {
      folderID
      createdAt
      __typename
    }
    isExcludedFromReporting
    additionalRoles
    altUsername
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserMutationVariables,
  APITypes.UpdateUserMutation
>;
export const deleteUser = /* GraphQL */ `mutation DeleteUser(
  $input: DeleteUserInput!
  $condition: ModelUserConditionInput
) {
  deleteUser(input: $input, condition: $condition) {
    id
    cognitoSubId
    tenantId
    email
    givenName
    phoneNumber
    familyName
    meetingId
    defaultFiltersCustomValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    lockedFiltersCustomValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    defaultFilterValues {
      key
      values
      __typename
    }
    lockedFilters {
      key
      values
      __typename
    }
    shareBCC
    shareCC
    createdAt
    createdBy
    updatedAt
    status
    role
    bookmarkedDocs {
      docID
      createdAt
      __typename
    }
    bookmarkedFolders {
      folderID
      createdAt
      __typename
    }
    isExcludedFromReporting
    additionalRoles
    altUsername
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserMutationVariables,
  APITypes.DeleteUserMutation
>;
export const createTenant = /* GraphQL */ `mutation CreateTenant(
  $input: CreateTenantInput!
  $condition: ModelTenantConditionInput
) {
  createTenant(input: $input, condition: $condition) {
    id
    name
    licensedUsers
    licensedViewOnlyUsers
    status
    folderUpdateGracePeriodDays
    medInfoURL
    medInfoLabel
    featureFlags {
      flagId
      value
      __typename
    }
    createdAt
    createdBy
    updatedAt
    statusChangedAt
    statusChangedBy
    ssoDomains
    integrations
    config {
      requiredSlidesHiddenMessage
      aiSearchDisclaimer
      forms {
        id
        name
        label
        fields {
          id
          fieldName
          fieldLabel
          reportingName
          status
          description
          required
          maxLength
          formatValidation
          fieldType
          showByDefault
          dependentFieldId
          controlType
          order
          settings {
            isBadge
            fieldPosition
            __typename
          }
          usage
          action
          actionSkip
          documentSettings {
            fieldPosition
            __typename
          }
          fieldValueDefinitions {
            id
            value
            label
            disabled
            isDefault
            documentSettings {
              presentationWatermarkText
              permission {
                present
                modify
                share
                download
                externalNotation
                __typename
              }
              __typename
            }
            disabledUserPermissions
            badgeColor
            badgeLabel
            createdAt
            dependentValueIds
            __typename
          }
          displayOnParentSelection
          displayOnValueSelection
          objectSetting {
            childrenFieldIds
            restriction {
              syncUpdate
              syncDelete
              update
              delete
              __typename
            }
            __typename
          }
          isChildField
          dateRestriction
          createdAt
          scaleNumber
          precisionNumber
          __typename
        }
        targetRequestTemplate
        targetType
        targetAddress
        targetParameters {
          key
          value
          __typename
        }
        status
        __typename
      }
      customFields {
        id
        fieldName
        fieldLabel
        reportingName
        status
        description
        required
        maxLength
        formatValidation
        fieldType
        showByDefault
        dependentFieldId
        controlType
        order
        settings {
          isBadge
          fieldPosition
          __typename
        }
        usage
        action
        actionSkip
        documentSettings {
          fieldPosition
          __typename
        }
        fieldValueDefinitions {
          id
          value
          label
          disabled
          isDefault
          documentSettings {
            presentationWatermarkText
            permission {
              present
              modify
              share
              download
              externalNotation
              __typename
            }
            __typename
          }
          disabledUserPermissions
          badgeColor
          badgeLabel
          createdAt
          dependentValueIds
          __typename
        }
        displayOnParentSelection
        displayOnValueSelection
        objectSetting {
          childrenFieldIds
          restriction {
            syncUpdate
            syncDelete
            update
            delete
            __typename
          }
          __typename
        }
        isChildField
        dateRestriction
        createdAt
        scaleNumber
        precisionNumber
        __typename
      }
      customStyle {
        color {
          primary
          __typename
        }
        __typename
      }
      defaultDocumentPermissions {
        present
        modify
        share
        download
        externalNotation
        __typename
      }
      mslListConfig {
        sort {
          field
          isAsc
          __typename
        }
        fields {
          field
          width
          __typename
        }
        filterDisplayFields {
          field
          width
          __typename
        }
        __typename
      }
      publisherListConfig {
        sort {
          field
          isAsc
          __typename
        }
        fields {
          field
          width
          __typename
        }
        filterDisplayFields {
          field
          width
          __typename
        }
        __typename
      }
      crmIntegration {
        id
        crmIntegrationType
        instanceUrl
        clientId
        redirectUri
        name
        accountsSettings {
          query
          displaySettings {
            shortened
            extended
            __typename
          }
          addressSettings {
            alias
            displaySettings {
              shortened
              extended
              __typename
            }
            __typename
          }
          __typename
        }
        meetingSetting {
          apiName
          presentationsFieldName
          children {
            name
            apiName
            relationshipName
            type
            veevaSetting {
              markerFieldName
              __typename
            }
            __typename
          }
          type
          __typename
        }
        additionalSettings {
          refreshSessionIntervalInMinutes
          allowCommentsOnTasks
          detailContentTableSettings {
            name
            apiName
            relationshipName
            prefix
            __typename
          }
          enableSurveys
          crmAccountToObjectSettings {
            accountFieldNames {
              accountFieldName
              objectFieldName
              __typename
            }
            apiName
            __typename
          }
          __typename
        }
        loginUrl
        externalOidcSso {
          issuer
          authorizationEndpoint
          tokenEndpoint
          clientId
          redirectUri
          vaultSessionEndpoint
          scope
          __typename
        }
        crmStandaloneForms {
          id
          apiName
          children {
            name
            apiName
            relationshipName
            type
            veevaSetting {
              markerFieldName
              __typename
            }
            __typename
          }
          type
          parents {
            apiName
            relationshipName
            __typename
          }
          usage
          __typename
        }
        __typename
      }
      sessionTimeout
      quickFilters {
        id
        label
        path
        __typename
      }
      hubsConfig {
        shareExpirationDays
        disabledSections
        disableNotationDescription
        __typename
      }
      reports {
        key
        value
        __typename
      }
      emailDocumentUpdateFrequency
      emailReportConfig {
        type
        frequency
        recipients
        customFieldColumns
        __typename
      }
      sharePPTXasPDF
      customDeckAcknowledgement {
        shouldShow
        content
        __typename
      }
      preferredBeaconDomain
      namedFilter {
        name
        filter {
          fieldId
          valueId
          __typename
        }
        __typename
      }
      __typename
    }
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTenantMutationVariables,
  APITypes.CreateTenantMutation
>;
export const updateTenant = /* GraphQL */ `mutation UpdateTenant(
  $input: UpdateTenantInput!
  $condition: ModelTenantConditionInput
) {
  updateTenant(input: $input, condition: $condition) {
    id
    name
    licensedUsers
    licensedViewOnlyUsers
    status
    folderUpdateGracePeriodDays
    medInfoURL
    medInfoLabel
    featureFlags {
      flagId
      value
      __typename
    }
    createdAt
    createdBy
    updatedAt
    statusChangedAt
    statusChangedBy
    ssoDomains
    integrations
    config {
      requiredSlidesHiddenMessage
      aiSearchDisclaimer
      forms {
        id
        name
        label
        fields {
          id
          fieldName
          fieldLabel
          reportingName
          status
          description
          required
          maxLength
          formatValidation
          fieldType
          showByDefault
          dependentFieldId
          controlType
          order
          settings {
            isBadge
            fieldPosition
            __typename
          }
          usage
          action
          actionSkip
          documentSettings {
            fieldPosition
            __typename
          }
          fieldValueDefinitions {
            id
            value
            label
            disabled
            isDefault
            documentSettings {
              presentationWatermarkText
              permission {
                present
                modify
                share
                download
                externalNotation
                __typename
              }
              __typename
            }
            disabledUserPermissions
            badgeColor
            badgeLabel
            createdAt
            dependentValueIds
            __typename
          }
          displayOnParentSelection
          displayOnValueSelection
          objectSetting {
            childrenFieldIds
            restriction {
              syncUpdate
              syncDelete
              update
              delete
              __typename
            }
            __typename
          }
          isChildField
          dateRestriction
          createdAt
          scaleNumber
          precisionNumber
          __typename
        }
        targetRequestTemplate
        targetType
        targetAddress
        targetParameters {
          key
          value
          __typename
        }
        status
        __typename
      }
      customFields {
        id
        fieldName
        fieldLabel
        reportingName
        status
        description
        required
        maxLength
        formatValidation
        fieldType
        showByDefault
        dependentFieldId
        controlType
        order
        settings {
          isBadge
          fieldPosition
          __typename
        }
        usage
        action
        actionSkip
        documentSettings {
          fieldPosition
          __typename
        }
        fieldValueDefinitions {
          id
          value
          label
          disabled
          isDefault
          documentSettings {
            presentationWatermarkText
            permission {
              present
              modify
              share
              download
              externalNotation
              __typename
            }
            __typename
          }
          disabledUserPermissions
          badgeColor
          badgeLabel
          createdAt
          dependentValueIds
          __typename
        }
        displayOnParentSelection
        displayOnValueSelection
        objectSetting {
          childrenFieldIds
          restriction {
            syncUpdate
            syncDelete
            update
            delete
            __typename
          }
          __typename
        }
        isChildField
        dateRestriction
        createdAt
        scaleNumber
        precisionNumber
        __typename
      }
      customStyle {
        color {
          primary
          __typename
        }
        __typename
      }
      defaultDocumentPermissions {
        present
        modify
        share
        download
        externalNotation
        __typename
      }
      mslListConfig {
        sort {
          field
          isAsc
          __typename
        }
        fields {
          field
          width
          __typename
        }
        filterDisplayFields {
          field
          width
          __typename
        }
        __typename
      }
      publisherListConfig {
        sort {
          field
          isAsc
          __typename
        }
        fields {
          field
          width
          __typename
        }
        filterDisplayFields {
          field
          width
          __typename
        }
        __typename
      }
      crmIntegration {
        id
        crmIntegrationType
        instanceUrl
        clientId
        redirectUri
        name
        accountsSettings {
          query
          displaySettings {
            shortened
            extended
            __typename
          }
          addressSettings {
            alias
            displaySettings {
              shortened
              extended
              __typename
            }
            __typename
          }
          __typename
        }
        meetingSetting {
          apiName
          presentationsFieldName
          children {
            name
            apiName
            relationshipName
            type
            veevaSetting {
              markerFieldName
              __typename
            }
            __typename
          }
          type
          __typename
        }
        additionalSettings {
          refreshSessionIntervalInMinutes
          allowCommentsOnTasks
          detailContentTableSettings {
            name
            apiName
            relationshipName
            prefix
            __typename
          }
          enableSurveys
          crmAccountToObjectSettings {
            accountFieldNames {
              accountFieldName
              objectFieldName
              __typename
            }
            apiName
            __typename
          }
          __typename
        }
        loginUrl
        externalOidcSso {
          issuer
          authorizationEndpoint
          tokenEndpoint
          clientId
          redirectUri
          vaultSessionEndpoint
          scope
          __typename
        }
        crmStandaloneForms {
          id
          apiName
          children {
            name
            apiName
            relationshipName
            type
            veevaSetting {
              markerFieldName
              __typename
            }
            __typename
          }
          type
          parents {
            apiName
            relationshipName
            __typename
          }
          usage
          __typename
        }
        __typename
      }
      sessionTimeout
      quickFilters {
        id
        label
        path
        __typename
      }
      hubsConfig {
        shareExpirationDays
        disabledSections
        disableNotationDescription
        __typename
      }
      reports {
        key
        value
        __typename
      }
      emailDocumentUpdateFrequency
      emailReportConfig {
        type
        frequency
        recipients
        customFieldColumns
        __typename
      }
      sharePPTXasPDF
      customDeckAcknowledgement {
        shouldShow
        content
        __typename
      }
      preferredBeaconDomain
      namedFilter {
        name
        filter {
          fieldId
          valueId
          __typename
        }
        __typename
      }
      __typename
    }
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTenantMutationVariables,
  APITypes.UpdateTenantMutation
>;
export const deleteTenant = /* GraphQL */ `mutation DeleteTenant(
  $input: DeleteTenantInput!
  $condition: ModelTenantConditionInput
) {
  deleteTenant(input: $input, condition: $condition) {
    id
    name
    licensedUsers
    licensedViewOnlyUsers
    status
    folderUpdateGracePeriodDays
    medInfoURL
    medInfoLabel
    featureFlags {
      flagId
      value
      __typename
    }
    createdAt
    createdBy
    updatedAt
    statusChangedAt
    statusChangedBy
    ssoDomains
    integrations
    config {
      requiredSlidesHiddenMessage
      aiSearchDisclaimer
      forms {
        id
        name
        label
        fields {
          id
          fieldName
          fieldLabel
          reportingName
          status
          description
          required
          maxLength
          formatValidation
          fieldType
          showByDefault
          dependentFieldId
          controlType
          order
          settings {
            isBadge
            fieldPosition
            __typename
          }
          usage
          action
          actionSkip
          documentSettings {
            fieldPosition
            __typename
          }
          fieldValueDefinitions {
            id
            value
            label
            disabled
            isDefault
            documentSettings {
              presentationWatermarkText
              permission {
                present
                modify
                share
                download
                externalNotation
                __typename
              }
              __typename
            }
            disabledUserPermissions
            badgeColor
            badgeLabel
            createdAt
            dependentValueIds
            __typename
          }
          displayOnParentSelection
          displayOnValueSelection
          objectSetting {
            childrenFieldIds
            restriction {
              syncUpdate
              syncDelete
              update
              delete
              __typename
            }
            __typename
          }
          isChildField
          dateRestriction
          createdAt
          scaleNumber
          precisionNumber
          __typename
        }
        targetRequestTemplate
        targetType
        targetAddress
        targetParameters {
          key
          value
          __typename
        }
        status
        __typename
      }
      customFields {
        id
        fieldName
        fieldLabel
        reportingName
        status
        description
        required
        maxLength
        formatValidation
        fieldType
        showByDefault
        dependentFieldId
        controlType
        order
        settings {
          isBadge
          fieldPosition
          __typename
        }
        usage
        action
        actionSkip
        documentSettings {
          fieldPosition
          __typename
        }
        fieldValueDefinitions {
          id
          value
          label
          disabled
          isDefault
          documentSettings {
            presentationWatermarkText
            permission {
              present
              modify
              share
              download
              externalNotation
              __typename
            }
            __typename
          }
          disabledUserPermissions
          badgeColor
          badgeLabel
          createdAt
          dependentValueIds
          __typename
        }
        displayOnParentSelection
        displayOnValueSelection
        objectSetting {
          childrenFieldIds
          restriction {
            syncUpdate
            syncDelete
            update
            delete
            __typename
          }
          __typename
        }
        isChildField
        dateRestriction
        createdAt
        scaleNumber
        precisionNumber
        __typename
      }
      customStyle {
        color {
          primary
          __typename
        }
        __typename
      }
      defaultDocumentPermissions {
        present
        modify
        share
        download
        externalNotation
        __typename
      }
      mslListConfig {
        sort {
          field
          isAsc
          __typename
        }
        fields {
          field
          width
          __typename
        }
        filterDisplayFields {
          field
          width
          __typename
        }
        __typename
      }
      publisherListConfig {
        sort {
          field
          isAsc
          __typename
        }
        fields {
          field
          width
          __typename
        }
        filterDisplayFields {
          field
          width
          __typename
        }
        __typename
      }
      crmIntegration {
        id
        crmIntegrationType
        instanceUrl
        clientId
        redirectUri
        name
        accountsSettings {
          query
          displaySettings {
            shortened
            extended
            __typename
          }
          addressSettings {
            alias
            displaySettings {
              shortened
              extended
              __typename
            }
            __typename
          }
          __typename
        }
        meetingSetting {
          apiName
          presentationsFieldName
          children {
            name
            apiName
            relationshipName
            type
            veevaSetting {
              markerFieldName
              __typename
            }
            __typename
          }
          type
          __typename
        }
        additionalSettings {
          refreshSessionIntervalInMinutes
          allowCommentsOnTasks
          detailContentTableSettings {
            name
            apiName
            relationshipName
            prefix
            __typename
          }
          enableSurveys
          crmAccountToObjectSettings {
            accountFieldNames {
              accountFieldName
              objectFieldName
              __typename
            }
            apiName
            __typename
          }
          __typename
        }
        loginUrl
        externalOidcSso {
          issuer
          authorizationEndpoint
          tokenEndpoint
          clientId
          redirectUri
          vaultSessionEndpoint
          scope
          __typename
        }
        crmStandaloneForms {
          id
          apiName
          children {
            name
            apiName
            relationshipName
            type
            veevaSetting {
              markerFieldName
              __typename
            }
            __typename
          }
          type
          parents {
            apiName
            relationshipName
            __typename
          }
          usage
          __typename
        }
        __typename
      }
      sessionTimeout
      quickFilters {
        id
        label
        path
        __typename
      }
      hubsConfig {
        shareExpirationDays
        disabledSections
        disableNotationDescription
        __typename
      }
      reports {
        key
        value
        __typename
      }
      emailDocumentUpdateFrequency
      emailReportConfig {
        type
        frequency
        recipients
        customFieldColumns
        __typename
      }
      sharePPTXasPDF
      customDeckAcknowledgement {
        shouldShow
        content
        __typename
      }
      preferredBeaconDomain
      namedFilter {
        name
        filter {
          fieldId
          valueId
          __typename
        }
        __typename
      }
      __typename
    }
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTenantMutationVariables,
  APITypes.DeleteTenantMutation
>;
export const createUserSettings = /* GraphQL */ `mutation CreateUserSettings(
  $input: CreateUserSettingsInput!
  $condition: ModelUserSettingsConditionInput
) {
  createUserSettings(input: $input, condition: $condition) {
    id
    userId
    tenantId
    analyticsFeed {
      documentsViewed {
        maxCount
        events {
          entityId
          timestamp
          __typename
        }
        __typename
      }
      foldersViewed {
        maxCount
        events {
          entityId
          timestamp
          __typename
        }
        __typename
      }
      __typename
    }
    viewedBulletinIds
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserSettingsMutationVariables,
  APITypes.CreateUserSettingsMutation
>;
export const updateUserSettings = /* GraphQL */ `mutation UpdateUserSettings(
  $input: UpdateUserSettingsInput!
  $condition: ModelUserSettingsConditionInput
) {
  updateUserSettings(input: $input, condition: $condition) {
    id
    userId
    tenantId
    analyticsFeed {
      documentsViewed {
        maxCount
        events {
          entityId
          timestamp
          __typename
        }
        __typename
      }
      foldersViewed {
        maxCount
        events {
          entityId
          timestamp
          __typename
        }
        __typename
      }
      __typename
    }
    viewedBulletinIds
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserSettingsMutationVariables,
  APITypes.UpdateUserSettingsMutation
>;
export const deleteUserSettings = /* GraphQL */ `mutation DeleteUserSettings(
  $input: DeleteUserSettingsInput!
  $condition: ModelUserSettingsConditionInput
) {
  deleteUserSettings(input: $input, condition: $condition) {
    id
    userId
    tenantId
    analyticsFeed {
      documentsViewed {
        maxCount
        events {
          entityId
          timestamp
          __typename
        }
        __typename
      }
      foldersViewed {
        maxCount
        events {
          entityId
          timestamp
          __typename
        }
        __typename
      }
      __typename
    }
    viewedBulletinIds
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserSettingsMutationVariables,
  APITypes.DeleteUserSettingsMutation
>;
export const createDocumentVersion = /* GraphQL */ `mutation CreateDocumentVersion(
  $input: CreateDocumentVersionInput!
  $condition: ModelDocumentVersionConditionInput
) {
  createDocumentVersion(input: $input, condition: $condition) {
    id
    tenantId
    documentId
    versionNumber
    srcFilename
    contentURL
    conversionStatus
    status
    srcFile {
      bucket
      region
      key
      url
      __typename
    }
    srcHash
    srcSize
    numPages
    pageSettings {
      pageId
      number
      isRequired
      isHidden
      sourceIsHidden
      linkedSlides
      __typename
    }
    pageGroups {
      id
      pageIds
      name
      locked
      sourceID
      source
      __typename
    }
    type
    releaseNotes
    changeType
    labelValues {
      key
      value
      __typename
    }
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    aiGeneratedLabels {
      categoryKey
      categoryLabel
      value
      normalizedValue
      modelId
      confidence
      evidence
      generatedAt
      __typename
    }
    title
    shortDescription
    shortSummary
    longDescription
    owner
    expiresAt
    hasCopyright
    hasCustomThumbnail
    purpose
    canHideSlides
    distributable
    downloadable
    isInternalGenerated
    semVer {
      minor
      major
      __typename
    }
    notificationScope
    syncScope
    selectedThumbnail
    publishedAt
    uploadedAt
    uploadedBy
    convertedArchiveKey
    convertedArchiveSize
    convertedFolderKey
    associatedFiles {
      id
      isDistributable
      isDefault
      type
      attachmentId
      status
      createdAt
      createdBy
      __typename
    }
    editPermissions
    converterVersion
    createdAt
    createdBy
    updatedAt
    updatedBy
    integration {
      externalVersionId
      version
      timestamp
      srcFileHash
      srcMappedMetadataHash
      __typename
    }
    integrationType
    conversionWarningCode
    conversionErrorCode
    scheduledPublish
    mappingStatus
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDocumentVersionMutationVariables,
  APITypes.CreateDocumentVersionMutation
>;
export const updateDocumentVersion = /* GraphQL */ `mutation UpdateDocumentVersion(
  $input: UpdateDocumentVersionInput!
  $condition: ModelDocumentVersionConditionInput
) {
  updateDocumentVersion(input: $input, condition: $condition) {
    id
    tenantId
    documentId
    versionNumber
    srcFilename
    contentURL
    conversionStatus
    status
    srcFile {
      bucket
      region
      key
      url
      __typename
    }
    srcHash
    srcSize
    numPages
    pageSettings {
      pageId
      number
      isRequired
      isHidden
      sourceIsHidden
      linkedSlides
      __typename
    }
    pageGroups {
      id
      pageIds
      name
      locked
      sourceID
      source
      __typename
    }
    type
    releaseNotes
    changeType
    labelValues {
      key
      value
      __typename
    }
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    aiGeneratedLabels {
      categoryKey
      categoryLabel
      value
      normalizedValue
      modelId
      confidence
      evidence
      generatedAt
      __typename
    }
    title
    shortDescription
    shortSummary
    longDescription
    owner
    expiresAt
    hasCopyright
    hasCustomThumbnail
    purpose
    canHideSlides
    distributable
    downloadable
    isInternalGenerated
    semVer {
      minor
      major
      __typename
    }
    notificationScope
    syncScope
    selectedThumbnail
    publishedAt
    uploadedAt
    uploadedBy
    convertedArchiveKey
    convertedArchiveSize
    convertedFolderKey
    associatedFiles {
      id
      isDistributable
      isDefault
      type
      attachmentId
      status
      createdAt
      createdBy
      __typename
    }
    editPermissions
    converterVersion
    createdAt
    createdBy
    updatedAt
    updatedBy
    integration {
      externalVersionId
      version
      timestamp
      srcFileHash
      srcMappedMetadataHash
      __typename
    }
    integrationType
    conversionWarningCode
    conversionErrorCode
    scheduledPublish
    mappingStatus
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDocumentVersionMutationVariables,
  APITypes.UpdateDocumentVersionMutation
>;
export const deleteDocumentVersion = /* GraphQL */ `mutation DeleteDocumentVersion(
  $input: DeleteDocumentVersionInput!
  $condition: ModelDocumentVersionConditionInput
) {
  deleteDocumentVersion(input: $input, condition: $condition) {
    id
    tenantId
    documentId
    versionNumber
    srcFilename
    contentURL
    conversionStatus
    status
    srcFile {
      bucket
      region
      key
      url
      __typename
    }
    srcHash
    srcSize
    numPages
    pageSettings {
      pageId
      number
      isRequired
      isHidden
      sourceIsHidden
      linkedSlides
      __typename
    }
    pageGroups {
      id
      pageIds
      name
      locked
      sourceID
      source
      __typename
    }
    type
    releaseNotes
    changeType
    labelValues {
      key
      value
      __typename
    }
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    aiGeneratedLabels {
      categoryKey
      categoryLabel
      value
      normalizedValue
      modelId
      confidence
      evidence
      generatedAt
      __typename
    }
    title
    shortDescription
    shortSummary
    longDescription
    owner
    expiresAt
    hasCopyright
    hasCustomThumbnail
    purpose
    canHideSlides
    distributable
    downloadable
    isInternalGenerated
    semVer {
      minor
      major
      __typename
    }
    notificationScope
    syncScope
    selectedThumbnail
    publishedAt
    uploadedAt
    uploadedBy
    convertedArchiveKey
    convertedArchiveSize
    convertedFolderKey
    associatedFiles {
      id
      isDistributable
      isDefault
      type
      attachmentId
      status
      createdAt
      createdBy
      __typename
    }
    editPermissions
    converterVersion
    createdAt
    createdBy
    updatedAt
    updatedBy
    integration {
      externalVersionId
      version
      timestamp
      srcFileHash
      srcMappedMetadataHash
      __typename
    }
    integrationType
    conversionWarningCode
    conversionErrorCode
    scheduledPublish
    mappingStatus
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDocumentVersionMutationVariables,
  APITypes.DeleteDocumentVersionMutation
>;
export const createAttachedFile = /* GraphQL */ `mutation CreateAttachedFile(
  $input: CreateAttachedFileInput!
  $condition: ModelAttachedFileConditionInput
) {
  createAttachedFile(input: $input, condition: $condition) {
    id
    title
    tenantId
    documentId
    srcFile {
      bucket
      region
      key
      url
      __typename
    }
    srcFileName
    srcHash
    srcSize
    type
    editPermissions
    createdAt
    createdBy
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAttachedFileMutationVariables,
  APITypes.CreateAttachedFileMutation
>;
export const updateAttachedFile = /* GraphQL */ `mutation UpdateAttachedFile(
  $input: UpdateAttachedFileInput!
  $condition: ModelAttachedFileConditionInput
) {
  updateAttachedFile(input: $input, condition: $condition) {
    id
    title
    tenantId
    documentId
    srcFile {
      bucket
      region
      key
      url
      __typename
    }
    srcFileName
    srcHash
    srcSize
    type
    editPermissions
    createdAt
    createdBy
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAttachedFileMutationVariables,
  APITypes.UpdateAttachedFileMutation
>;
export const deleteAttachedFile = /* GraphQL */ `mutation DeleteAttachedFile(
  $input: DeleteAttachedFileInput!
  $condition: ModelAttachedFileConditionInput
) {
  deleteAttachedFile(input: $input, condition: $condition) {
    id
    title
    tenantId
    documentId
    srcFile {
      bucket
      region
      key
      url
      __typename
    }
    srcFileName
    srcHash
    srcSize
    type
    editPermissions
    createdAt
    createdBy
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAttachedFileMutationVariables,
  APITypes.DeleteAttachedFileMutation
>;
export const createDocument = /* GraphQL */ `mutation CreateDocument(
  $input: CreateDocumentInput!
  $condition: ModelDocumentConditionInput
) {
  createDocument(input: $input, condition: $condition) {
    id
    tenantId
    accessLevel
    status
    owner
    expiresAt
    integration {
      integrationId
      externalId
      firstSync
      lastSync
      __typename
    }
    integrationType
    type
    editPermissions
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDocumentMutationVariables,
  APITypes.CreateDocumentMutation
>;
export const updateDocument = /* GraphQL */ `mutation UpdateDocument(
  $input: UpdateDocumentInput!
  $condition: ModelDocumentConditionInput
) {
  updateDocument(input: $input, condition: $condition) {
    id
    tenantId
    accessLevel
    status
    owner
    expiresAt
    integration {
      integrationId
      externalId
      firstSync
      lastSync
      __typename
    }
    integrationType
    type
    editPermissions
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDocumentMutationVariables,
  APITypes.UpdateDocumentMutation
>;
export const deleteDocument = /* GraphQL */ `mutation DeleteDocument(
  $input: DeleteDocumentInput!
  $condition: ModelDocumentConditionInput
) {
  deleteDocument(input: $input, condition: $condition) {
    id
    tenantId
    accessLevel
    status
    owner
    expiresAt
    integration {
      integrationId
      externalId
      firstSync
      lastSync
      __typename
    }
    integrationType
    type
    editPermissions
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDocumentMutationVariables,
  APITypes.DeleteDocumentMutation
>;
export const createEmailTemplate = /* GraphQL */ `mutation CreateEmailTemplate(
  $input: CreateEmailTemplateInput!
  $condition: ModelEmailTemplateConditionInput
) {
  createEmailTemplate(input: $input, condition: $condition) {
    id
    tenantId
    labelValues {
      key
      value
      __typename
    }
    customFilterValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    subject
    title
    cc
    bcc
    body
    associatedFiles {
      id
      isDistributable
      isDefault
      type
      attachmentId
      status
      createdAt
      createdBy
      __typename
    }
    status
    editPermissions
    createdBy
    createdAt
    updatedBy
    updatedAt
    type
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEmailTemplateMutationVariables,
  APITypes.CreateEmailTemplateMutation
>;
export const updateEmailTemplate = /* GraphQL */ `mutation UpdateEmailTemplate(
  $input: UpdateEmailTemplateInput!
  $condition: ModelEmailTemplateConditionInput
) {
  updateEmailTemplate(input: $input, condition: $condition) {
    id
    tenantId
    labelValues {
      key
      value
      __typename
    }
    customFilterValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    subject
    title
    cc
    bcc
    body
    associatedFiles {
      id
      isDistributable
      isDefault
      type
      attachmentId
      status
      createdAt
      createdBy
      __typename
    }
    status
    editPermissions
    createdBy
    createdAt
    updatedBy
    updatedAt
    type
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEmailTemplateMutationVariables,
  APITypes.UpdateEmailTemplateMutation
>;
export const deleteEmailTemplate = /* GraphQL */ `mutation DeleteEmailTemplate(
  $input: DeleteEmailTemplateInput!
  $condition: ModelEmailTemplateConditionInput
) {
  deleteEmailTemplate(input: $input, condition: $condition) {
    id
    tenantId
    labelValues {
      key
      value
      __typename
    }
    customFilterValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    subject
    title
    cc
    bcc
    body
    associatedFiles {
      id
      isDistributable
      isDefault
      type
      attachmentId
      status
      createdAt
      createdBy
      __typename
    }
    status
    editPermissions
    createdBy
    createdAt
    updatedBy
    updatedAt
    type
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEmailTemplateMutationVariables,
  APITypes.DeleteEmailTemplateMutation
>;
export const createUserDocumentVersionSettings = /* GraphQL */ `mutation CreateUserDocumentVersionSettings(
  $input: CreateUserDocumentVersionSettingsInput!
  $condition: ModelUserDocumentVersionSettingsConditionInput
) {
  createUserDocumentVersionSettings(input: $input, condition: $condition) {
    id
    tenantId
    createdAt
    createdBy
    updatedAt
    updatedBy
    documentId
    documentVersionId
    customDeckId
    pageSettings {
      pageId
      hidden
      __typename
    }
    status
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserDocumentVersionSettingsMutationVariables,
  APITypes.CreateUserDocumentVersionSettingsMutation
>;
export const updateUserDocumentVersionSettings = /* GraphQL */ `mutation UpdateUserDocumentVersionSettings(
  $input: UpdateUserDocumentVersionSettingsInput!
  $condition: ModelUserDocumentVersionSettingsConditionInput
) {
  updateUserDocumentVersionSettings(input: $input, condition: $condition) {
    id
    tenantId
    createdAt
    createdBy
    updatedAt
    updatedBy
    documentId
    documentVersionId
    customDeckId
    pageSettings {
      pageId
      hidden
      __typename
    }
    status
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserDocumentVersionSettingsMutationVariables,
  APITypes.UpdateUserDocumentVersionSettingsMutation
>;
export const deleteUserDocumentVersionSettings = /* GraphQL */ `mutation DeleteUserDocumentVersionSettings(
  $input: DeleteUserDocumentVersionSettingsInput!
  $condition: ModelUserDocumentVersionSettingsConditionInput
) {
  deleteUserDocumentVersionSettings(input: $input, condition: $condition) {
    id
    tenantId
    createdAt
    createdBy
    updatedAt
    updatedBy
    documentId
    documentVersionId
    customDeckId
    pageSettings {
      pageId
      hidden
      __typename
    }
    status
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserDocumentVersionSettingsMutationVariables,
  APITypes.DeleteUserDocumentVersionSettingsMutation
>;
export const createUserNotations = /* GraphQL */ `mutation CreateUserNotations(
  $input: CreateUserNotationsInput!
  $condition: ModelUserNotationsConditionInput
) {
  createUserNotations(input: $input, condition: $condition) {
    id
    tenantId
    createdAt
    createdBy
    updatedAt
    updatedBy
    documentId
    documentVersionId
    customDeckId
    notation {
      id
      type
      description
      status
      pageId
      coordinate {
        x
        y
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      __typename
    }
    status
    type
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserNotationsMutationVariables,
  APITypes.CreateUserNotationsMutation
>;
export const updateUserNotations = /* GraphQL */ `mutation UpdateUserNotations(
  $input: UpdateUserNotationsInput!
  $condition: ModelUserNotationsConditionInput
) {
  updateUserNotations(input: $input, condition: $condition) {
    id
    tenantId
    createdAt
    createdBy
    updatedAt
    updatedBy
    documentId
    documentVersionId
    customDeckId
    notation {
      id
      type
      description
      status
      pageId
      coordinate {
        x
        y
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      __typename
    }
    status
    type
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserNotationsMutationVariables,
  APITypes.UpdateUserNotationsMutation
>;
export const deleteUserNotations = /* GraphQL */ `mutation DeleteUserNotations(
  $input: DeleteUserNotationsInput!
  $condition: ModelUserNotationsConditionInput
) {
  deleteUserNotations(input: $input, condition: $condition) {
    id
    tenantId
    createdAt
    createdBy
    updatedAt
    updatedBy
    documentId
    documentVersionId
    customDeckId
    notation {
      id
      type
      description
      status
      pageId
      coordinate {
        x
        y
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      __typename
    }
    status
    type
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserNotationsMutationVariables,
  APITypes.DeleteUserNotationsMutation
>;
export const createCustomDeck = /* GraphQL */ `mutation CreateCustomDeck(
  $input: CreateCustomDeckInput!
  $condition: ModelCustomDeckConditionInput
) {
  createCustomDeck(input: $input, condition: $condition) {
    id
    createdAt
    createdBy
    autoUpdateAcknowledgedAt
    updatedAt
    updatedBy
    tenantId
    groups {
      id
      pages {
        pageId
        pageNumber
        documentVersionId
        __typename
      }
      visible
      srcId
      docAccessLevel
      name
      locked
      __typename
    }
    title
    editMutex {
      userId
      timeStarted
      lastSeenAt
      __typename
    }
    sourceCustomDeckId
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCustomDeckMutationVariables,
  APITypes.CreateCustomDeckMutation
>;
export const updateCustomDeck = /* GraphQL */ `mutation UpdateCustomDeck(
  $input: UpdateCustomDeckInput!
  $condition: ModelCustomDeckConditionInput
) {
  updateCustomDeck(input: $input, condition: $condition) {
    id
    createdAt
    createdBy
    autoUpdateAcknowledgedAt
    updatedAt
    updatedBy
    tenantId
    groups {
      id
      pages {
        pageId
        pageNumber
        documentVersionId
        __typename
      }
      visible
      srcId
      docAccessLevel
      name
      locked
      __typename
    }
    title
    editMutex {
      userId
      timeStarted
      lastSeenAt
      __typename
    }
    sourceCustomDeckId
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCustomDeckMutationVariables,
  APITypes.UpdateCustomDeckMutation
>;
export const deleteCustomDeck = /* GraphQL */ `mutation DeleteCustomDeck(
  $input: DeleteCustomDeckInput!
  $condition: ModelCustomDeckConditionInput
) {
  deleteCustomDeck(input: $input, condition: $condition) {
    id
    createdAt
    createdBy
    autoUpdateAcknowledgedAt
    updatedAt
    updatedBy
    tenantId
    groups {
      id
      pages {
        pageId
        pageNumber
        documentVersionId
        __typename
      }
      visible
      srcId
      docAccessLevel
      name
      locked
      __typename
    }
    title
    editMutex {
      userId
      timeStarted
      lastSeenAt
      __typename
    }
    sourceCustomDeckId
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCustomDeckMutationVariables,
  APITypes.DeleteCustomDeckMutation
>;
export const createFolder = /* GraphQL */ `mutation CreateFolder(
  $input: CreateFolderInput!
  $condition: ModelFolderConditionInput
) {
  createFolder(input: $input, condition: $condition) {
    id
    tenantId
    name
    isPinned
    status
    items {
      id
      type
      itemId
      status
      addedAt
      updateAcknowledgedAt
      itemLastUpdatedAt
      visiblePages
      customTitle
      __typename
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
    sharePermissions {
      id
      isDeleted
      type
      targetType
      targetUsername
      targetCustomValues {
        fieldId
        objectRecords {
          id
          externalId
          syncStatus
          status
          values {
            fieldId
            values
            __typename
          }
          __typename
        }
        values
        __typename
      }
      targetLabels {
        key
        values
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      deletedBy
      deletedAt
      __typename
    }
    shareStatus
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFolderMutationVariables,
  APITypes.CreateFolderMutation
>;
export const updateFolder = /* GraphQL */ `mutation UpdateFolder(
  $input: UpdateFolderInput!
  $condition: ModelFolderConditionInput
) {
  updateFolder(input: $input, condition: $condition) {
    id
    tenantId
    name
    isPinned
    status
    items {
      id
      type
      itemId
      status
      addedAt
      updateAcknowledgedAt
      itemLastUpdatedAt
      visiblePages
      customTitle
      __typename
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
    sharePermissions {
      id
      isDeleted
      type
      targetType
      targetUsername
      targetCustomValues {
        fieldId
        objectRecords {
          id
          externalId
          syncStatus
          status
          values {
            fieldId
            values
            __typename
          }
          __typename
        }
        values
        __typename
      }
      targetLabels {
        key
        values
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      deletedBy
      deletedAt
      __typename
    }
    shareStatus
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFolderMutationVariables,
  APITypes.UpdateFolderMutation
>;
export const deleteFolder = /* GraphQL */ `mutation DeleteFolder(
  $input: DeleteFolderInput!
  $condition: ModelFolderConditionInput
) {
  deleteFolder(input: $input, condition: $condition) {
    id
    tenantId
    name
    isPinned
    status
    items {
      id
      type
      itemId
      status
      addedAt
      updateAcknowledgedAt
      itemLastUpdatedAt
      visiblePages
      customTitle
      __typename
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
    sharePermissions {
      id
      isDeleted
      type
      targetType
      targetUsername
      targetCustomValues {
        fieldId
        objectRecords {
          id
          externalId
          syncStatus
          status
          values {
            fieldId
            values
            __typename
          }
          __typename
        }
        values
        __typename
      }
      targetLabels {
        key
        values
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      deletedBy
      deletedAt
      __typename
    }
    shareStatus
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFolderMutationVariables,
  APITypes.DeleteFolderMutation
>;
export const createContentShare = /* GraphQL */ `mutation CreateContentShare(
  $input: CreateContentShareInput!
  $condition: ModelContentShareConditionInput
) {
  createContentShare(input: $input, condition: $condition) {
    id
    token
    tenantId
    type
    contentId
    meetingId
    expiresAt
    createdAt
    updatedAt
    createdBy
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    pageSettings {
      pageId
      hidden
      __typename
    }
    revoked
    customDeckDependencies {
      versions
      folderId
      __typename
    }
    notificationScope
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateContentShareMutationVariables,
  APITypes.CreateContentShareMutation
>;
export const updateContentShare = /* GraphQL */ `mutation UpdateContentShare(
  $input: UpdateContentShareInput!
  $condition: ModelContentShareConditionInput
) {
  updateContentShare(input: $input, condition: $condition) {
    id
    token
    tenantId
    type
    contentId
    meetingId
    expiresAt
    createdAt
    updatedAt
    createdBy
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    pageSettings {
      pageId
      hidden
      __typename
    }
    revoked
    customDeckDependencies {
      versions
      folderId
      __typename
    }
    notificationScope
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateContentShareMutationVariables,
  APITypes.UpdateContentShareMutation
>;
export const deleteContentShare = /* GraphQL */ `mutation DeleteContentShare(
  $input: DeleteContentShareInput!
  $condition: ModelContentShareConditionInput
) {
  deleteContentShare(input: $input, condition: $condition) {
    id
    token
    tenantId
    type
    contentId
    meetingId
    expiresAt
    createdAt
    updatedAt
    createdBy
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    pageSettings {
      pageId
      hidden
      __typename
    }
    revoked
    customDeckDependencies {
      versions
      folderId
      __typename
    }
    notificationScope
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteContentShareMutationVariables,
  APITypes.DeleteContentShareMutation
>;
export const createIntegrationLog = /* GraphQL */ `mutation CreateIntegrationLog(
  $input: CreateIntegrationLogInput!
  $condition: ModelIntegrationLogConditionInput
) {
  createIntegrationLog(input: $input, condition: $condition) {
    integrationId
    id
    log {
      level
      timestamp
      message
      srcDocId
      srcDocVersion
      __typename
    }
    status
    tenantId
    createdAt
    updatedAt
    purgeAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateIntegrationLogMutationVariables,
  APITypes.CreateIntegrationLogMutation
>;
export const updateIntegrationLog = /* GraphQL */ `mutation UpdateIntegrationLog(
  $input: UpdateIntegrationLogInput!
  $condition: ModelIntegrationLogConditionInput
) {
  updateIntegrationLog(input: $input, condition: $condition) {
    integrationId
    id
    log {
      level
      timestamp
      message
      srcDocId
      srcDocVersion
      __typename
    }
    status
    tenantId
    createdAt
    updatedAt
    purgeAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateIntegrationLogMutationVariables,
  APITypes.UpdateIntegrationLogMutation
>;
export const deleteIntegrationLog = /* GraphQL */ `mutation DeleteIntegrationLog(
  $input: DeleteIntegrationLogInput!
  $condition: ModelIntegrationLogConditionInput
) {
  deleteIntegrationLog(input: $input, condition: $condition) {
    integrationId
    id
    log {
      level
      timestamp
      message
      srcDocId
      srcDocVersion
      __typename
    }
    status
    tenantId
    createdAt
    updatedAt
    purgeAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteIntegrationLogMutationVariables,
  APITypes.DeleteIntegrationLogMutation
>;
export const createIntegrationSettings = /* GraphQL */ `mutation CreateIntegrationSettings(
  $input: CreateIntegrationSettingsInput!
  $condition: ModelIntegrationSettingsConditionInput
) {
  createIntegrationSettings(input: $input, condition: $condition) {
    id
    tenantId
    syncContentEvery
    name
    mapping {
      key
      fieldType
      dataType
      targetFieldName
      srcFieldname
      valueMappings {
        srcValue
        targetValue
        __typename
      }
      __typename
    }
    clientConfigurationFields {
      key
      value
      __typename
    }
    integrationType
    enabled
    notificationEmail
    errorSyncEmail
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateIntegrationSettingsMutationVariables,
  APITypes.CreateIntegrationSettingsMutation
>;
export const updateIntegrationSettings = /* GraphQL */ `mutation UpdateIntegrationSettings(
  $input: UpdateIntegrationSettingsInput!
  $condition: ModelIntegrationSettingsConditionInput
) {
  updateIntegrationSettings(input: $input, condition: $condition) {
    id
    tenantId
    syncContentEvery
    name
    mapping {
      key
      fieldType
      dataType
      targetFieldName
      srcFieldname
      valueMappings {
        srcValue
        targetValue
        __typename
      }
      __typename
    }
    clientConfigurationFields {
      key
      value
      __typename
    }
    integrationType
    enabled
    notificationEmail
    errorSyncEmail
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateIntegrationSettingsMutationVariables,
  APITypes.UpdateIntegrationSettingsMutation
>;
export const deleteIntegrationSettings = /* GraphQL */ `mutation DeleteIntegrationSettings(
  $input: DeleteIntegrationSettingsInput!
  $condition: ModelIntegrationSettingsConditionInput
) {
  deleteIntegrationSettings(input: $input, condition: $condition) {
    id
    tenantId
    syncContentEvery
    name
    mapping {
      key
      fieldType
      dataType
      targetFieldName
      srcFieldname
      valueMappings {
        srcValue
        targetValue
        __typename
      }
      __typename
    }
    clientConfigurationFields {
      key
      value
      __typename
    }
    integrationType
    enabled
    notificationEmail
    errorSyncEmail
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteIntegrationSettingsMutationVariables,
  APITypes.DeleteIntegrationSettingsMutation
>;
export const createTrainingEvent = /* GraphQL */ `mutation CreateTrainingEvent(
  $input: CreateTrainingEventInput!
  $condition: ModelTrainingEventConditionInput
) {
  createTrainingEvent(input: $input, condition: $condition) {
    id
    tenantId
    startDateTime
    endDateTime
    title
    trainingEventUsers {
      userId
      email
      givenName
      familyName
      __typename
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
    deleted
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTrainingEventMutationVariables,
  APITypes.CreateTrainingEventMutation
>;
export const updateTrainingEvent = /* GraphQL */ `mutation UpdateTrainingEvent(
  $input: UpdateTrainingEventInput!
  $condition: ModelTrainingEventConditionInput
) {
  updateTrainingEvent(input: $input, condition: $condition) {
    id
    tenantId
    startDateTime
    endDateTime
    title
    trainingEventUsers {
      userId
      email
      givenName
      familyName
      __typename
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
    deleted
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTrainingEventMutationVariables,
  APITypes.UpdateTrainingEventMutation
>;
export const deleteTrainingEvent = /* GraphQL */ `mutation DeleteTrainingEvent(
  $input: DeleteTrainingEventInput!
  $condition: ModelTrainingEventConditionInput
) {
  deleteTrainingEvent(input: $input, condition: $condition) {
    id
    tenantId
    startDateTime
    endDateTime
    title
    trainingEventUsers {
      userId
      email
      givenName
      familyName
      __typename
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
    deleted
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTrainingEventMutationVariables,
  APITypes.DeleteTrainingEventMutation
>;
export const createMeeting = /* GraphQL */ `mutation CreateMeeting(
  $input: CreateMeetingInput!
  $condition: ModelMeetingConditionInput
) {
  createMeeting(input: $input, condition: $condition) {
    id
    tenantId
    title
    startTime
    endTime
    contentPresented {
      contentId
      groupId
      folderItemId
      title
      groupTitle
      status
      contentType
      events {
        pageNumber
        pageId
        timestamp
        end
        __typename
      }
      openedAt
      closedAt
      presentedMeta {
        pageId
        presented
        followUp
        sentiment
        note
        title
        __typename
      }
      __typename
    }
    type
    fieldValues {
      fieldId
      valueOrId
      __typename
    }
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    notes
    status
    createdAt
    createdBy
    updatedAt
    updatedBy
    attendees {
      id
      name
      status
      updatedAt
      email
      crmAccountId
      crmAddressId
      crmUserId
      attendeeType
      crmRecord {
        crmCallId
        crmCallName
        crmCustomValues {
          fieldId
          objectRecords {
            id
            externalId
            syncStatus
            status
            values {
              fieldId
              values
              __typename
            }
            __typename
          }
          values
          __typename
        }
        crmSyncStatus
        lastSyncedAt
        __typename
      }
      lastSyncedAt
      __typename
    }
    crmRecord {
      crmCallId
      crmCallName
      crmCustomValues {
        fieldId
        objectRecords {
          id
          externalId
          syncStatus
          status
          values {
            fieldId
            values
            __typename
          }
          __typename
        }
        values
        __typename
      }
      crmSyncStatus
      lastSyncedAt
      __typename
    }
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMeetingMutationVariables,
  APITypes.CreateMeetingMutation
>;
export const updateMeeting = /* GraphQL */ `mutation UpdateMeeting(
  $input: UpdateMeetingInput!
  $condition: ModelMeetingConditionInput
) {
  updateMeeting(input: $input, condition: $condition) {
    id
    tenantId
    title
    startTime
    endTime
    contentPresented {
      contentId
      groupId
      folderItemId
      title
      groupTitle
      status
      contentType
      events {
        pageNumber
        pageId
        timestamp
        end
        __typename
      }
      openedAt
      closedAt
      presentedMeta {
        pageId
        presented
        followUp
        sentiment
        note
        title
        __typename
      }
      __typename
    }
    type
    fieldValues {
      fieldId
      valueOrId
      __typename
    }
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    notes
    status
    createdAt
    createdBy
    updatedAt
    updatedBy
    attendees {
      id
      name
      status
      updatedAt
      email
      crmAccountId
      crmAddressId
      crmUserId
      attendeeType
      crmRecord {
        crmCallId
        crmCallName
        crmCustomValues {
          fieldId
          objectRecords {
            id
            externalId
            syncStatus
            status
            values {
              fieldId
              values
              __typename
            }
            __typename
          }
          values
          __typename
        }
        crmSyncStatus
        lastSyncedAt
        __typename
      }
      lastSyncedAt
      __typename
    }
    crmRecord {
      crmCallId
      crmCallName
      crmCustomValues {
        fieldId
        objectRecords {
          id
          externalId
          syncStatus
          status
          values {
            fieldId
            values
            __typename
          }
          __typename
        }
        values
        __typename
      }
      crmSyncStatus
      lastSyncedAt
      __typename
    }
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMeetingMutationVariables,
  APITypes.UpdateMeetingMutation
>;
export const deleteMeeting = /* GraphQL */ `mutation DeleteMeeting(
  $input: DeleteMeetingInput!
  $condition: ModelMeetingConditionInput
) {
  deleteMeeting(input: $input, condition: $condition) {
    id
    tenantId
    title
    startTime
    endTime
    contentPresented {
      contentId
      groupId
      folderItemId
      title
      groupTitle
      status
      contentType
      events {
        pageNumber
        pageId
        timestamp
        end
        __typename
      }
      openedAt
      closedAt
      presentedMeta {
        pageId
        presented
        followUp
        sentiment
        note
        title
        __typename
      }
      __typename
    }
    type
    fieldValues {
      fieldId
      valueOrId
      __typename
    }
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    notes
    status
    createdAt
    createdBy
    updatedAt
    updatedBy
    attendees {
      id
      name
      status
      updatedAt
      email
      crmAccountId
      crmAddressId
      crmUserId
      attendeeType
      crmRecord {
        crmCallId
        crmCallName
        crmCustomValues {
          fieldId
          objectRecords {
            id
            externalId
            syncStatus
            status
            values {
              fieldId
              values
              __typename
            }
            __typename
          }
          values
          __typename
        }
        crmSyncStatus
        lastSyncedAt
        __typename
      }
      lastSyncedAt
      __typename
    }
    crmRecord {
      crmCallId
      crmCallName
      crmCustomValues {
        fieldId
        objectRecords {
          id
          externalId
          syncStatus
          status
          values {
            fieldId
            values
            __typename
          }
          __typename
        }
        values
        __typename
      }
      crmSyncStatus
      lastSyncedAt
      __typename
    }
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMeetingMutationVariables,
  APITypes.DeleteMeetingMutation
>;
export const createHub = /* GraphQL */ `mutation CreateHub(
  $input: CreateHubInput!
  $condition: ModelHubConditionInput
) {
  createHub(input: $input, condition: $condition) {
    id
    tenantId
    name
    status
    createdAt
    createdBy
    updatedAt
    updatedBy
    hubSections {
      id
      sectionHeader
      status
      type
      visible
      order
      textarea {
        content
        __typename
      }
      sharedFiles {
        id
        contentId
        title
        contentType
        documentVersionSettings {
          associatedFiles {
            associatedFileId
            versionId
            notation {
              id
              type
              description
              status
              pageId
              coordinate {
                x
                y
                __typename
              }
              createdAt
              createdBy
              updatedAt
              updatedBy
              __typename
            }
            __typename
          }
          __typename
        }
        status
        order
        createdAt
        updatedAt
        notation {
          id
          type
          description
          status
          pageId
          coordinate {
            x
            y
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          __typename
        }
        pageSettings {
          pageId
          hidden
          __typename
        }
        pageGroups {
          id
          pageIds
          name
          locked
          sourceID
          source
          __typename
        }
        renderInline
        __typename
      }
      toDos {
        id
        title
        status
        completedAt
        resolution
        order
        createdAt
        updatedAt
        __typename
      }
      links {
        id
        url
        title
        status
        order
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      locked
      __typename
    }
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    meetingId
    templateId
    copiedFromHubId
    editPermissions
    readPermissions
    sharedPermissions {
      id
      isDeleted
      type
      targetType
      targetUsername
      targetCustomValues {
        fieldId
        objectRecords {
          id
          externalId
          syncStatus
          status
          values {
            fieldId
            values
            __typename
          }
          __typename
        }
        values
        __typename
      }
      targetLabels {
        key
        values
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      deletedBy
      deletedAt
      __typename
    }
    hubType
    lockName
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateHubMutationVariables,
  APITypes.CreateHubMutation
>;
export const updateHub = /* GraphQL */ `mutation UpdateHub(
  $input: UpdateHubInput!
  $condition: ModelHubConditionInput
) {
  updateHub(input: $input, condition: $condition) {
    id
    tenantId
    name
    status
    createdAt
    createdBy
    updatedAt
    updatedBy
    hubSections {
      id
      sectionHeader
      status
      type
      visible
      order
      textarea {
        content
        __typename
      }
      sharedFiles {
        id
        contentId
        title
        contentType
        documentVersionSettings {
          associatedFiles {
            associatedFileId
            versionId
            notation {
              id
              type
              description
              status
              pageId
              coordinate {
                x
                y
                __typename
              }
              createdAt
              createdBy
              updatedAt
              updatedBy
              __typename
            }
            __typename
          }
          __typename
        }
        status
        order
        createdAt
        updatedAt
        notation {
          id
          type
          description
          status
          pageId
          coordinate {
            x
            y
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          __typename
        }
        pageSettings {
          pageId
          hidden
          __typename
        }
        pageGroups {
          id
          pageIds
          name
          locked
          sourceID
          source
          __typename
        }
        renderInline
        __typename
      }
      toDos {
        id
        title
        status
        completedAt
        resolution
        order
        createdAt
        updatedAt
        __typename
      }
      links {
        id
        url
        title
        status
        order
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      locked
      __typename
    }
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    meetingId
    templateId
    copiedFromHubId
    editPermissions
    readPermissions
    sharedPermissions {
      id
      isDeleted
      type
      targetType
      targetUsername
      targetCustomValues {
        fieldId
        objectRecords {
          id
          externalId
          syncStatus
          status
          values {
            fieldId
            values
            __typename
          }
          __typename
        }
        values
        __typename
      }
      targetLabels {
        key
        values
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      deletedBy
      deletedAt
      __typename
    }
    hubType
    lockName
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateHubMutationVariables,
  APITypes.UpdateHubMutation
>;
export const deleteHub = /* GraphQL */ `mutation DeleteHub(
  $input: DeleteHubInput!
  $condition: ModelHubConditionInput
) {
  deleteHub(input: $input, condition: $condition) {
    id
    tenantId
    name
    status
    createdAt
    createdBy
    updatedAt
    updatedBy
    hubSections {
      id
      sectionHeader
      status
      type
      visible
      order
      textarea {
        content
        __typename
      }
      sharedFiles {
        id
        contentId
        title
        contentType
        documentVersionSettings {
          associatedFiles {
            associatedFileId
            versionId
            notation {
              id
              type
              description
              status
              pageId
              coordinate {
                x
                y
                __typename
              }
              createdAt
              createdBy
              updatedAt
              updatedBy
              __typename
            }
            __typename
          }
          __typename
        }
        status
        order
        createdAt
        updatedAt
        notation {
          id
          type
          description
          status
          pageId
          coordinate {
            x
            y
            __typename
          }
          createdAt
          createdBy
          updatedAt
          updatedBy
          __typename
        }
        pageSettings {
          pageId
          hidden
          __typename
        }
        pageGroups {
          id
          pageIds
          name
          locked
          sourceID
          source
          __typename
        }
        renderInline
        __typename
      }
      toDos {
        id
        title
        status
        completedAt
        resolution
        order
        createdAt
        updatedAt
        __typename
      }
      links {
        id
        url
        title
        status
        order
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      locked
      __typename
    }
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    meetingId
    templateId
    copiedFromHubId
    editPermissions
    readPermissions
    sharedPermissions {
      id
      isDeleted
      type
      targetType
      targetUsername
      targetCustomValues {
        fieldId
        objectRecords {
          id
          externalId
          syncStatus
          status
          values {
            fieldId
            values
            __typename
          }
          __typename
        }
        values
        __typename
      }
      targetLabels {
        key
        values
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      deletedBy
      deletedAt
      __typename
    }
    hubType
    lockName
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteHubMutationVariables,
  APITypes.DeleteHubMutation
>;
export const createCustomFormRecord = /* GraphQL */ `mutation CreateCustomFormRecord(
  $input: CreateCustomFormRecordInput!
  $condition: ModelCustomFormRecordConditionInput
) {
  createCustomFormRecord(input: $input, condition: $condition) {
    id
    tenantId
    customFormId
    entity
    status
    crmFields {
      accountId
      externalId
      apiName
      recordTypeId
      syncStatus
      lastSyncedAt
      __typename
    }
    name
    parentId
    parentModel
    values {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCustomFormRecordMutationVariables,
  APITypes.CreateCustomFormRecordMutation
>;
export const updateCustomFormRecord = /* GraphQL */ `mutation UpdateCustomFormRecord(
  $input: UpdateCustomFormRecordInput!
  $condition: ModelCustomFormRecordConditionInput
) {
  updateCustomFormRecord(input: $input, condition: $condition) {
    id
    tenantId
    customFormId
    entity
    status
    crmFields {
      accountId
      externalId
      apiName
      recordTypeId
      syncStatus
      lastSyncedAt
      __typename
    }
    name
    parentId
    parentModel
    values {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCustomFormRecordMutationVariables,
  APITypes.UpdateCustomFormRecordMutation
>;
export const deleteCustomFormRecord = /* GraphQL */ `mutation DeleteCustomFormRecord(
  $input: DeleteCustomFormRecordInput!
  $condition: ModelCustomFormRecordConditionInput
) {
  deleteCustomFormRecord(input: $input, condition: $condition) {
    id
    tenantId
    customFormId
    entity
    status
    crmFields {
      accountId
      externalId
      apiName
      recordTypeId
      syncStatus
      lastSyncedAt
      __typename
    }
    name
    parentId
    parentModel
    values {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCustomFormRecordMutationVariables,
  APITypes.DeleteCustomFormRecordMutation
>;
export const createPromptValues = /* GraphQL */ `mutation CreatePromptValues(
  $input: CreatePromptValuesInput!
  $condition: ModelPromptValuesConditionInput
) {
  createPromptValues(input: $input, condition: $condition) {
    id
    tenantId
    promptType
    status
    value
    editPermissions
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePromptValuesMutationVariables,
  APITypes.CreatePromptValuesMutation
>;
export const updatePromptValues = /* GraphQL */ `mutation UpdatePromptValues(
  $input: UpdatePromptValuesInput!
  $condition: ModelPromptValuesConditionInput
) {
  updatePromptValues(input: $input, condition: $condition) {
    id
    tenantId
    promptType
    status
    value
    editPermissions
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePromptValuesMutationVariables,
  APITypes.UpdatePromptValuesMutation
>;
export const deletePromptValues = /* GraphQL */ `mutation DeletePromptValues(
  $input: DeletePromptValuesInput!
  $condition: ModelPromptValuesConditionInput
) {
  deletePromptValues(input: $input, condition: $condition) {
    id
    tenantId
    promptType
    status
    value
    editPermissions
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePromptValuesMutationVariables,
  APITypes.DeletePromptValuesMutation
>;
export const createBulletin = /* GraphQL */ `mutation CreateBulletin(
  $input: CreateBulletinInput!
  $condition: ModelBulletinConditionInput
) {
  createBulletin(input: $input, condition: $condition) {
    id
    tenantId
    title
    content
    status
    publishedAt
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBulletinMutationVariables,
  APITypes.CreateBulletinMutation
>;
export const updateBulletin = /* GraphQL */ `mutation UpdateBulletin(
  $input: UpdateBulletinInput!
  $condition: ModelBulletinConditionInput
) {
  updateBulletin(input: $input, condition: $condition) {
    id
    tenantId
    title
    content
    status
    publishedAt
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBulletinMutationVariables,
  APITypes.UpdateBulletinMutation
>;
export const deleteBulletin = /* GraphQL */ `mutation DeleteBulletin(
  $input: DeleteBulletinInput!
  $condition: ModelBulletinConditionInput
) {
  deleteBulletin(input: $input, condition: $condition) {
    id
    tenantId
    title
    content
    status
    publishedAt
    createdAt
    createdBy
    updatedAt
    updatedBy
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBulletinMutationVariables,
  APITypes.DeleteBulletinMutation
>;
export const createTenantLambda = /* GraphQL */ `mutation CreateTenantLambda($tenant: CreateTenantInputLambda) {
  createTenantLambda(tenant: $tenant) {
    id
    name
    licensedUsers
    licensedViewOnlyUsers
    status
    folderUpdateGracePeriodDays
    medInfoURL
    medInfoLabel
    featureFlags {
      flagId
      value
      __typename
    }
    createdAt
    createdBy
    updatedAt
    statusChangedAt
    statusChangedBy
    ssoDomains
    integrations
    config {
      requiredSlidesHiddenMessage
      aiSearchDisclaimer
      forms {
        id
        name
        label
        fields {
          id
          fieldName
          fieldLabel
          reportingName
          status
          description
          required
          maxLength
          formatValidation
          fieldType
          showByDefault
          dependentFieldId
          controlType
          order
          settings {
            isBadge
            fieldPosition
            __typename
          }
          usage
          action
          actionSkip
          documentSettings {
            fieldPosition
            __typename
          }
          fieldValueDefinitions {
            id
            value
            label
            disabled
            isDefault
            documentSettings {
              presentationWatermarkText
              permission {
                present
                modify
                share
                download
                externalNotation
                __typename
              }
              __typename
            }
            disabledUserPermissions
            badgeColor
            badgeLabel
            createdAt
            dependentValueIds
            __typename
          }
          displayOnParentSelection
          displayOnValueSelection
          objectSetting {
            childrenFieldIds
            restriction {
              syncUpdate
              syncDelete
              update
              delete
              __typename
            }
            __typename
          }
          isChildField
          dateRestriction
          createdAt
          scaleNumber
          precisionNumber
          __typename
        }
        targetRequestTemplate
        targetType
        targetAddress
        targetParameters {
          key
          value
          __typename
        }
        status
        __typename
      }
      customFields {
        id
        fieldName
        fieldLabel
        reportingName
        status
        description
        required
        maxLength
        formatValidation
        fieldType
        showByDefault
        dependentFieldId
        controlType
        order
        settings {
          isBadge
          fieldPosition
          __typename
        }
        usage
        action
        actionSkip
        documentSettings {
          fieldPosition
          __typename
        }
        fieldValueDefinitions {
          id
          value
          label
          disabled
          isDefault
          documentSettings {
            presentationWatermarkText
            permission {
              present
              modify
              share
              download
              externalNotation
              __typename
            }
            __typename
          }
          disabledUserPermissions
          badgeColor
          badgeLabel
          createdAt
          dependentValueIds
          __typename
        }
        displayOnParentSelection
        displayOnValueSelection
        objectSetting {
          childrenFieldIds
          restriction {
            syncUpdate
            syncDelete
            update
            delete
            __typename
          }
          __typename
        }
        isChildField
        dateRestriction
        createdAt
        scaleNumber
        precisionNumber
        __typename
      }
      customStyle {
        color {
          primary
          __typename
        }
        __typename
      }
      defaultDocumentPermissions {
        present
        modify
        share
        download
        externalNotation
        __typename
      }
      mslListConfig {
        sort {
          field
          isAsc
          __typename
        }
        fields {
          field
          width
          __typename
        }
        filterDisplayFields {
          field
          width
          __typename
        }
        __typename
      }
      publisherListConfig {
        sort {
          field
          isAsc
          __typename
        }
        fields {
          field
          width
          __typename
        }
        filterDisplayFields {
          field
          width
          __typename
        }
        __typename
      }
      crmIntegration {
        id
        crmIntegrationType
        instanceUrl
        clientId
        redirectUri
        name
        accountsSettings {
          query
          displaySettings {
            shortened
            extended
            __typename
          }
          addressSettings {
            alias
            displaySettings {
              shortened
              extended
              __typename
            }
            __typename
          }
          __typename
        }
        meetingSetting {
          apiName
          presentationsFieldName
          children {
            name
            apiName
            relationshipName
            type
            veevaSetting {
              markerFieldName
              __typename
            }
            __typename
          }
          type
          __typename
        }
        additionalSettings {
          refreshSessionIntervalInMinutes
          allowCommentsOnTasks
          detailContentTableSettings {
            name
            apiName
            relationshipName
            prefix
            __typename
          }
          enableSurveys
          crmAccountToObjectSettings {
            accountFieldNames {
              accountFieldName
              objectFieldName
              __typename
            }
            apiName
            __typename
          }
          __typename
        }
        loginUrl
        externalOidcSso {
          issuer
          authorizationEndpoint
          tokenEndpoint
          clientId
          redirectUri
          vaultSessionEndpoint
          scope
          __typename
        }
        crmStandaloneForms {
          id
          apiName
          children {
            name
            apiName
            relationshipName
            type
            veevaSetting {
              markerFieldName
              __typename
            }
            __typename
          }
          type
          parents {
            apiName
            relationshipName
            __typename
          }
          usage
          __typename
        }
        __typename
      }
      sessionTimeout
      quickFilters {
        id
        label
        path
        __typename
      }
      hubsConfig {
        shareExpirationDays
        disabledSections
        disableNotationDescription
        __typename
      }
      reports {
        key
        value
        __typename
      }
      emailDocumentUpdateFrequency
      emailReportConfig {
        type
        frequency
        recipients
        customFieldColumns
        __typename
      }
      sharePPTXasPDF
      customDeckAcknowledgement {
        shouldShow
        content
        __typename
      }
      preferredBeaconDomain
      namedFilter {
        name
        filter {
          fieldId
          valueId
          __typename
        }
        __typename
      }
      __typename
    }
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTenantLambdaMutationVariables,
  APITypes.CreateTenantLambdaMutation
>;
export const createDocumentFromS3Upload = /* GraphQL */ `mutation CreateDocumentFromS3Upload(
  $inputDoc: CreateDocumentFromS3UploadInput!
) {
  createDocumentFromS3Upload(inputDoc: $inputDoc) {
    id
    tenantId
    documentId
    versionNumber
    srcFilename
    contentURL
    conversionStatus
    status
    srcFile {
      bucket
      region
      key
      url
      __typename
    }
    srcHash
    srcSize
    numPages
    pageSettings {
      pageId
      number
      isRequired
      isHidden
      sourceIsHidden
      linkedSlides
      __typename
    }
    pageGroups {
      id
      pageIds
      name
      locked
      sourceID
      source
      __typename
    }
    type
    releaseNotes
    changeType
    labelValues {
      key
      value
      __typename
    }
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    aiGeneratedLabels {
      categoryKey
      categoryLabel
      value
      normalizedValue
      modelId
      confidence
      evidence
      generatedAt
      __typename
    }
    title
    shortDescription
    shortSummary
    longDescription
    owner
    expiresAt
    hasCopyright
    hasCustomThumbnail
    purpose
    canHideSlides
    distributable
    downloadable
    isInternalGenerated
    semVer {
      minor
      major
      __typename
    }
    notificationScope
    syncScope
    selectedThumbnail
    publishedAt
    uploadedAt
    uploadedBy
    convertedArchiveKey
    convertedArchiveSize
    convertedFolderKey
    associatedFiles {
      id
      isDistributable
      isDefault
      type
      attachmentId
      status
      createdAt
      createdBy
      __typename
    }
    editPermissions
    converterVersion
    createdAt
    createdBy
    updatedAt
    updatedBy
    integration {
      externalVersionId
      version
      timestamp
      srcFileHash
      srcMappedMetadataHash
      __typename
    }
    integrationType
    conversionWarningCode
    conversionErrorCode
    scheduledPublish
    mappingStatus
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDocumentFromS3UploadMutationVariables,
  APITypes.CreateDocumentFromS3UploadMutation
>;
export const createUserDocumentFromS3Upload = /* GraphQL */ `mutation CreateUserDocumentFromS3Upload(
  $inputDoc: CreateDocumentFromS3UploadInput!
) {
  createUserDocumentFromS3Upload(inputDoc: $inputDoc) {
    id
    tenantId
    documentId
    versionNumber
    srcFilename
    contentURL
    conversionStatus
    status
    srcFile {
      bucket
      region
      key
      url
      __typename
    }
    srcHash
    srcSize
    numPages
    pageSettings {
      pageId
      number
      isRequired
      isHidden
      sourceIsHidden
      linkedSlides
      __typename
    }
    pageGroups {
      id
      pageIds
      name
      locked
      sourceID
      source
      __typename
    }
    type
    releaseNotes
    changeType
    labelValues {
      key
      value
      __typename
    }
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    aiGeneratedLabels {
      categoryKey
      categoryLabel
      value
      normalizedValue
      modelId
      confidence
      evidence
      generatedAt
      __typename
    }
    title
    shortDescription
    shortSummary
    longDescription
    owner
    expiresAt
    hasCopyright
    hasCustomThumbnail
    purpose
    canHideSlides
    distributable
    downloadable
    isInternalGenerated
    semVer {
      minor
      major
      __typename
    }
    notificationScope
    syncScope
    selectedThumbnail
    publishedAt
    uploadedAt
    uploadedBy
    convertedArchiveKey
    convertedArchiveSize
    convertedFolderKey
    associatedFiles {
      id
      isDistributable
      isDefault
      type
      attachmentId
      status
      createdAt
      createdBy
      __typename
    }
    editPermissions
    converterVersion
    createdAt
    createdBy
    updatedAt
    updatedBy
    integration {
      externalVersionId
      version
      timestamp
      srcFileHash
      srcMappedMetadataHash
      __typename
    }
    integrationType
    conversionWarningCode
    conversionErrorCode
    scheduledPublish
    mappingStatus
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserDocumentFromS3UploadMutationVariables,
  APITypes.CreateUserDocumentFromS3UploadMutation
>;
export const createWebDocument = /* GraphQL */ `mutation CreateWebDocument {
  createWebDocument {
    id
    tenantId
    documentId
    versionNumber
    srcFilename
    contentURL
    conversionStatus
    status
    srcFile {
      bucket
      region
      key
      url
      __typename
    }
    srcHash
    srcSize
    numPages
    pageSettings {
      pageId
      number
      isRequired
      isHidden
      sourceIsHidden
      linkedSlides
      __typename
    }
    pageGroups {
      id
      pageIds
      name
      locked
      sourceID
      source
      __typename
    }
    type
    releaseNotes
    changeType
    labelValues {
      key
      value
      __typename
    }
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    aiGeneratedLabels {
      categoryKey
      categoryLabel
      value
      normalizedValue
      modelId
      confidence
      evidence
      generatedAt
      __typename
    }
    title
    shortDescription
    shortSummary
    longDescription
    owner
    expiresAt
    hasCopyright
    hasCustomThumbnail
    purpose
    canHideSlides
    distributable
    downloadable
    isInternalGenerated
    semVer {
      minor
      major
      __typename
    }
    notificationScope
    syncScope
    selectedThumbnail
    publishedAt
    uploadedAt
    uploadedBy
    convertedArchiveKey
    convertedArchiveSize
    convertedFolderKey
    associatedFiles {
      id
      isDistributable
      isDefault
      type
      attachmentId
      status
      createdAt
      createdBy
      __typename
    }
    editPermissions
    converterVersion
    createdAt
    createdBy
    updatedAt
    updatedBy
    integration {
      externalVersionId
      version
      timestamp
      srcFileHash
      srcMappedMetadataHash
      __typename
    }
    integrationType
    conversionWarningCode
    conversionErrorCode
    scheduledPublish
    mappingStatus
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateWebDocumentMutationVariables,
  APITypes.CreateWebDocumentMutation
>;
export const updateDocumentThumbnail = /* GraphQL */ `mutation UpdateDocumentThumbnail(
  $inputDocumentThumbnail: UpdateDocumentThumbnailInput!
) {
  updateDocumentThumbnail(inputDocumentThumbnail: $inputDocumentThumbnail) {
    id
    tenantId
    documentId
    versionNumber
    srcFilename
    contentURL
    conversionStatus
    status
    srcFile {
      bucket
      region
      key
      url
      __typename
    }
    srcHash
    srcSize
    numPages
    pageSettings {
      pageId
      number
      isRequired
      isHidden
      sourceIsHidden
      linkedSlides
      __typename
    }
    pageGroups {
      id
      pageIds
      name
      locked
      sourceID
      source
      __typename
    }
    type
    releaseNotes
    changeType
    labelValues {
      key
      value
      __typename
    }
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    aiGeneratedLabels {
      categoryKey
      categoryLabel
      value
      normalizedValue
      modelId
      confidence
      evidence
      generatedAt
      __typename
    }
    title
    shortDescription
    shortSummary
    longDescription
    owner
    expiresAt
    hasCopyright
    hasCustomThumbnail
    purpose
    canHideSlides
    distributable
    downloadable
    isInternalGenerated
    semVer {
      minor
      major
      __typename
    }
    notificationScope
    syncScope
    selectedThumbnail
    publishedAt
    uploadedAt
    uploadedBy
    convertedArchiveKey
    convertedArchiveSize
    convertedFolderKey
    associatedFiles {
      id
      isDistributable
      isDefault
      type
      attachmentId
      status
      createdAt
      createdBy
      __typename
    }
    editPermissions
    converterVersion
    createdAt
    createdBy
    updatedAt
    updatedBy
    integration {
      externalVersionId
      version
      timestamp
      srcFileHash
      srcMappedMetadataHash
      __typename
    }
    integrationType
    conversionWarningCode
    conversionErrorCode
    scheduledPublish
    mappingStatus
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDocumentThumbnailMutationVariables,
  APITypes.UpdateDocumentThumbnailMutation
>;
export const createDocumentFromS3UploadIntegrationEngine = /* GraphQL */ `mutation CreateDocumentFromS3UploadIntegrationEngine(
  $inputDoc: CreateDocumentFromS3UploadEngineInput!
) {
  createDocumentFromS3UploadIntegrationEngine(inputDoc: $inputDoc) {
    id
    tenantId
    documentId
    versionNumber
    srcFilename
    contentURL
    conversionStatus
    status
    srcFile {
      bucket
      region
      key
      url
      __typename
    }
    srcHash
    srcSize
    numPages
    pageSettings {
      pageId
      number
      isRequired
      isHidden
      sourceIsHidden
      linkedSlides
      __typename
    }
    pageGroups {
      id
      pageIds
      name
      locked
      sourceID
      source
      __typename
    }
    type
    releaseNotes
    changeType
    labelValues {
      key
      value
      __typename
    }
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    aiGeneratedLabels {
      categoryKey
      categoryLabel
      value
      normalizedValue
      modelId
      confidence
      evidence
      generatedAt
      __typename
    }
    title
    shortDescription
    shortSummary
    longDescription
    owner
    expiresAt
    hasCopyright
    hasCustomThumbnail
    purpose
    canHideSlides
    distributable
    downloadable
    isInternalGenerated
    semVer {
      minor
      major
      __typename
    }
    notificationScope
    syncScope
    selectedThumbnail
    publishedAt
    uploadedAt
    uploadedBy
    convertedArchiveKey
    convertedArchiveSize
    convertedFolderKey
    associatedFiles {
      id
      isDistributable
      isDefault
      type
      attachmentId
      status
      createdAt
      createdBy
      __typename
    }
    editPermissions
    converterVersion
    createdAt
    createdBy
    updatedAt
    updatedBy
    integration {
      externalVersionId
      version
      timestamp
      srcFileHash
      srcMappedMetadataHash
      __typename
    }
    integrationType
    conversionWarningCode
    conversionErrorCode
    scheduledPublish
    mappingStatus
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDocumentFromS3UploadIntegrationEngineMutationVariables,
  APITypes.CreateDocumentFromS3UploadIntegrationEngineMutation
>;
export const createDocumentVersionFromS3Upload = /* GraphQL */ `mutation CreateDocumentVersionFromS3Upload(
  $inputVersion: CreateDocumentVersionFromS3UploadInput!
) {
  createDocumentVersionFromS3Upload(inputVersion: $inputVersion) {
    id
    tenantId
    documentId
    versionNumber
    srcFilename
    contentURL
    conversionStatus
    status
    srcFile {
      bucket
      region
      key
      url
      __typename
    }
    srcHash
    srcSize
    numPages
    pageSettings {
      pageId
      number
      isRequired
      isHidden
      sourceIsHidden
      linkedSlides
      __typename
    }
    pageGroups {
      id
      pageIds
      name
      locked
      sourceID
      source
      __typename
    }
    type
    releaseNotes
    changeType
    labelValues {
      key
      value
      __typename
    }
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    aiGeneratedLabels {
      categoryKey
      categoryLabel
      value
      normalizedValue
      modelId
      confidence
      evidence
      generatedAt
      __typename
    }
    title
    shortDescription
    shortSummary
    longDescription
    owner
    expiresAt
    hasCopyright
    hasCustomThumbnail
    purpose
    canHideSlides
    distributable
    downloadable
    isInternalGenerated
    semVer {
      minor
      major
      __typename
    }
    notificationScope
    syncScope
    selectedThumbnail
    publishedAt
    uploadedAt
    uploadedBy
    convertedArchiveKey
    convertedArchiveSize
    convertedFolderKey
    associatedFiles {
      id
      isDistributable
      isDefault
      type
      attachmentId
      status
      createdAt
      createdBy
      __typename
    }
    editPermissions
    converterVersion
    createdAt
    createdBy
    updatedAt
    updatedBy
    integration {
      externalVersionId
      version
      timestamp
      srcFileHash
      srcMappedMetadataHash
      __typename
    }
    integrationType
    conversionWarningCode
    conversionErrorCode
    scheduledPublish
    mappingStatus
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDocumentVersionFromS3UploadMutationVariables,
  APITypes.CreateDocumentVersionFromS3UploadMutation
>;
export const createDocumentVersionFromS3UploadIntegrationEngine = /* GraphQL */ `mutation CreateDocumentVersionFromS3UploadIntegrationEngine(
  $inputVersion: CreateDocumentVersionFromS3UploadEngineInput!
) {
  createDocumentVersionFromS3UploadIntegrationEngine(
    inputVersion: $inputVersion
  ) {
    id
    tenantId
    documentId
    versionNumber
    srcFilename
    contentURL
    conversionStatus
    status
    srcFile {
      bucket
      region
      key
      url
      __typename
    }
    srcHash
    srcSize
    numPages
    pageSettings {
      pageId
      number
      isRequired
      isHidden
      sourceIsHidden
      linkedSlides
      __typename
    }
    pageGroups {
      id
      pageIds
      name
      locked
      sourceID
      source
      __typename
    }
    type
    releaseNotes
    changeType
    labelValues {
      key
      value
      __typename
    }
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    aiGeneratedLabels {
      categoryKey
      categoryLabel
      value
      normalizedValue
      modelId
      confidence
      evidence
      generatedAt
      __typename
    }
    title
    shortDescription
    shortSummary
    longDescription
    owner
    expiresAt
    hasCopyright
    hasCustomThumbnail
    purpose
    canHideSlides
    distributable
    downloadable
    isInternalGenerated
    semVer {
      minor
      major
      __typename
    }
    notificationScope
    syncScope
    selectedThumbnail
    publishedAt
    uploadedAt
    uploadedBy
    convertedArchiveKey
    convertedArchiveSize
    convertedFolderKey
    associatedFiles {
      id
      isDistributable
      isDefault
      type
      attachmentId
      status
      createdAt
      createdBy
      __typename
    }
    editPermissions
    converterVersion
    createdAt
    createdBy
    updatedAt
    updatedBy
    integration {
      externalVersionId
      version
      timestamp
      srcFileHash
      srcMappedMetadataHash
      __typename
    }
    integrationType
    conversionWarningCode
    conversionErrorCode
    scheduledPublish
    mappingStatus
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDocumentVersionFromS3UploadIntegrationEngineMutationVariables,
  APITypes.CreateDocumentVersionFromS3UploadIntegrationEngineMutation
>;
export const createDocumentVersionFromExisting = /* GraphQL */ `mutation CreateDocumentVersionFromExisting(
  $documentId: ID!
  $newVersionNumber: Int!
  $existingVersionId: ID!
) {
  createDocumentVersionFromExisting(
    documentId: $documentId
    newVersionNumber: $newVersionNumber
    existingVersionId: $existingVersionId
  ) {
    id
    tenantId
    documentId
    versionNumber
    srcFilename
    contentURL
    conversionStatus
    status
    srcFile {
      bucket
      region
      key
      url
      __typename
    }
    srcHash
    srcSize
    numPages
    pageSettings {
      pageId
      number
      isRequired
      isHidden
      sourceIsHidden
      linkedSlides
      __typename
    }
    pageGroups {
      id
      pageIds
      name
      locked
      sourceID
      source
      __typename
    }
    type
    releaseNotes
    changeType
    labelValues {
      key
      value
      __typename
    }
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    aiGeneratedLabels {
      categoryKey
      categoryLabel
      value
      normalizedValue
      modelId
      confidence
      evidence
      generatedAt
      __typename
    }
    title
    shortDescription
    shortSummary
    longDescription
    owner
    expiresAt
    hasCopyright
    hasCustomThumbnail
    purpose
    canHideSlides
    distributable
    downloadable
    isInternalGenerated
    semVer {
      minor
      major
      __typename
    }
    notificationScope
    syncScope
    selectedThumbnail
    publishedAt
    uploadedAt
    uploadedBy
    convertedArchiveKey
    convertedArchiveSize
    convertedFolderKey
    associatedFiles {
      id
      isDistributable
      isDefault
      type
      attachmentId
      status
      createdAt
      createdBy
      __typename
    }
    editPermissions
    converterVersion
    createdAt
    createdBy
    updatedAt
    updatedBy
    integration {
      externalVersionId
      version
      timestamp
      srcFileHash
      srcMappedMetadataHash
      __typename
    }
    integrationType
    conversionWarningCode
    conversionErrorCode
    scheduledPublish
    mappingStatus
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDocumentVersionFromExistingMutationVariables,
  APITypes.CreateDocumentVersionFromExistingMutation
>;
export const createDocumentVersionFromExistingIntegrationEngine = /* GraphQL */ `mutation CreateDocumentVersionFromExistingIntegrationEngine(
  $input: CreateDocumentVersionFromExistingEngineInput
) {
  createDocumentVersionFromExistingIntegrationEngine(input: $input) {
    id
    tenantId
    documentId
    versionNumber
    srcFilename
    contentURL
    conversionStatus
    status
    srcFile {
      bucket
      region
      key
      url
      __typename
    }
    srcHash
    srcSize
    numPages
    pageSettings {
      pageId
      number
      isRequired
      isHidden
      sourceIsHidden
      linkedSlides
      __typename
    }
    pageGroups {
      id
      pageIds
      name
      locked
      sourceID
      source
      __typename
    }
    type
    releaseNotes
    changeType
    labelValues {
      key
      value
      __typename
    }
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    aiGeneratedLabels {
      categoryKey
      categoryLabel
      value
      normalizedValue
      modelId
      confidence
      evidence
      generatedAt
      __typename
    }
    title
    shortDescription
    shortSummary
    longDescription
    owner
    expiresAt
    hasCopyright
    hasCustomThumbnail
    purpose
    canHideSlides
    distributable
    downloadable
    isInternalGenerated
    semVer {
      minor
      major
      __typename
    }
    notificationScope
    syncScope
    selectedThumbnail
    publishedAt
    uploadedAt
    uploadedBy
    convertedArchiveKey
    convertedArchiveSize
    convertedFolderKey
    associatedFiles {
      id
      isDistributable
      isDefault
      type
      attachmentId
      status
      createdAt
      createdBy
      __typename
    }
    editPermissions
    converterVersion
    createdAt
    createdBy
    updatedAt
    updatedBy
    integration {
      externalVersionId
      version
      timestamp
      srcFileHash
      srcMappedMetadataHash
      __typename
    }
    integrationType
    conversionWarningCode
    conversionErrorCode
    scheduledPublish
    mappingStatus
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDocumentVersionFromExistingIntegrationEngineMutationVariables,
  APITypes.CreateDocumentVersionFromExistingIntegrationEngineMutation
>;
export const createAttachedFileFromS3Upload = /* GraphQL */ `mutation CreateAttachedFileFromS3Upload(
  $inputAttached: CreateAttachedFileFromS3UploadInput!
) {
  createAttachedFileFromS3Upload(inputAttached: $inputAttached) {
    id
    title
    tenantId
    documentId
    srcFile {
      bucket
      region
      key
      url
      __typename
    }
    srcFileName
    srcHash
    srcSize
    type
    editPermissions
    createdAt
    createdBy
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAttachedFileFromS3UploadMutationVariables,
  APITypes.CreateAttachedFileFromS3UploadMutation
>;
export const downloadDocumentVersionAsPdfFile = /* GraphQL */ `mutation DownloadDocumentVersionAsPdfFile(
  $documentVersionId: ID!
  $pageSettings: [PageSettingOverrideInput!]
) {
  downloadDocumentVersionAsPdfFile(
    documentVersionId: $documentVersionId
    pageSettings: $pageSettings
  )
}
` as GeneratedMutation<
  APITypes.DownloadDocumentVersionAsPdfFileMutationVariables,
  APITypes.DownloadDocumentVersionAsPdfFileMutation
>;
export const downloadCustomDeckAsPdfFile = /* GraphQL */ `mutation DownloadCustomDeckAsPdfFile(
  $customDeckId: ID!
  $pageSettings: [PageSettingOverrideInput!]
) {
  downloadCustomDeckAsPdfFile(
    customDeckId: $customDeckId
    pageSettings: $pageSettings
  )
}
` as GeneratedMutation<
  APITypes.DownloadCustomDeckAsPdfFileMutationVariables,
  APITypes.DownloadCustomDeckAsPdfFileMutation
>;
export const downloadPdfFromPaths = /* GraphQL */ `mutation DownloadPdfFromPaths($pdfPaths: [String!]!, $tenantId: ID!) {
  downloadPdfFromPaths(pdfPaths: $pdfPaths, tenantId: $tenantId)
}
` as GeneratedMutation<
  APITypes.DownloadPdfFromPathsMutationVariables,
  APITypes.DownloadPdfFromPathsMutation
>;
export const generateContentShare = /* GraphQL */ `mutation GenerateContentShare(
  $type: SHARE_TYPE!
  $contentId: ID!
  $expiresInMins: Int!
  $customValues: [CustomValuesInput!]!
  $notificationScope: SHARE_NOTIFICATION_SCOPE
  $meetingId: String
  $customDeckDependencies: CustomDeckDependenciesInput
  $pageSettings: [PageSettingOverrideInput!]
) {
  generateContentShare(
    type: $type
    contentId: $contentId
    expiresInMins: $expiresInMins
    customValues: $customValues
    notificationScope: $notificationScope
    meetingId: $meetingId
    customDeckDependencies: $customDeckDependencies
    pageSettings: $pageSettings
  ) {
    id
    token
    tenantId
    type
    contentId
    meetingId
    expiresAt
    createdAt
    updatedAt
    createdBy
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    pageSettings {
      pageId
      hidden
      __typename
    }
    revoked
    customDeckDependencies {
      versions
      folderId
      __typename
    }
    notificationScope
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.GenerateContentShareMutationVariables,
  APITypes.GenerateContentShareMutation
>;
export const updateUserLambda = /* GraphQL */ `mutation UpdateUserLambda($user: UpdateUserLambdaInput) {
  updateUserLambda(user: $user) {
    id
    cognitoSubId
    tenantId
    email
    givenName
    phoneNumber
    familyName
    meetingId
    defaultFiltersCustomValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    lockedFiltersCustomValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    defaultFilterValues {
      key
      values
      __typename
    }
    lockedFilters {
      key
      values
      __typename
    }
    shareBCC
    shareCC
    createdAt
    createdBy
    updatedAt
    status
    role
    bookmarkedDocs {
      docID
      createdAt
      __typename
    }
    bookmarkedFolders {
      folderID
      createdAt
      __typename
    }
    isExcludedFromReporting
    additionalRoles
    altUsername
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserLambdaMutationVariables,
  APITypes.UpdateUserLambdaMutation
>;
export const updateCustomDeckLambda = /* GraphQL */ `mutation UpdateCustomDeckLambda(
  $customDeck: UpdateCustomDeckLambdaInput!
  $folderId: ID!
  $rootFolderId: ID!
) {
  updateCustomDeckLambda(
    customDeck: $customDeck
    folderId: $folderId
    rootFolderId: $rootFolderId
  ) {
    id
    createdAt
    createdBy
    autoUpdateAcknowledgedAt
    updatedAt
    updatedBy
    tenantId
    groups {
      id
      pages {
        pageId
        pageNumber
        documentVersionId
        __typename
      }
      visible
      srcId
      docAccessLevel
      name
      locked
      __typename
    }
    title
    editMutex {
      userId
      timeStarted
      lastSeenAt
      __typename
    }
    sourceCustomDeckId
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCustomDeckLambdaMutationVariables,
  APITypes.UpdateCustomDeckLambdaMutation
>;
export const updateUserStatusLambda = /* GraphQL */ `mutation UpdateUserStatusLambda($user: DisableUserLambdaInput) {
  updateUserStatusLambda(user: $user) {
    id
    cognitoSubId
    tenantId
    email
    givenName
    phoneNumber
    familyName
    meetingId
    defaultFiltersCustomValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    lockedFiltersCustomValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    defaultFilterValues {
      key
      values
      __typename
    }
    lockedFilters {
      key
      values
      __typename
    }
    shareBCC
    shareCC
    createdAt
    createdBy
    updatedAt
    status
    role
    bookmarkedDocs {
      docID
      createdAt
      __typename
    }
    bookmarkedFolders {
      folderID
      createdAt
      __typename
    }
    isExcludedFromReporting
    additionalRoles
    altUsername
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserStatusLambdaMutationVariables,
  APITypes.UpdateUserStatusLambdaMutation
>;
export const createTenantUser = /* GraphQL */ `mutation CreateTenantUser($user: CreateUserLambdaInput, $sendInvite: Boolean) {
  createTenantUser(user: $user, sendInvite: $sendInvite) {
    id
    cognitoSubId
    tenantId
    email
    givenName
    phoneNumber
    familyName
    meetingId
    defaultFiltersCustomValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    lockedFiltersCustomValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    defaultFilterValues {
      key
      values
      __typename
    }
    lockedFilters {
      key
      values
      __typename
    }
    shareBCC
    shareCC
    createdAt
    createdBy
    updatedAt
    status
    role
    bookmarkedDocs {
      docID
      createdAt
      __typename
    }
    bookmarkedFolders {
      folderID
      createdAt
      __typename
    }
    isExcludedFromReporting
    additionalRoles
    altUsername
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTenantUserMutationVariables,
  APITypes.CreateTenantUserMutation
>;
export const submitIntegrationRun = /* GraphQL */ `mutation SubmitIntegrationRun($input: RunIntegrationEngineInput) {
  submitIntegrationRun(input: $input) {
    success
    message
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SubmitIntegrationRunMutationVariables,
  APITypes.SubmitIntegrationRunMutation
>;
export const submitUserIntegrationRun = /* GraphQL */ `mutation SubmitUserIntegrationRun($input: RunIntegrationEngineInput) {
  submitUserIntegrationRun(input: $input) {
    success
    message
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SubmitUserIntegrationRunMutationVariables,
  APITypes.SubmitUserIntegrationRunMutation
>;
export const applyDocumentMapping = /* GraphQL */ `mutation ApplyDocumentMapping($input: DocumentMappingInput!) {
  applyDocumentMapping(input: $input) {
    status
    documentsUpdated
    versionsUpdated
    message
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ApplyDocumentMappingMutationVariables,
  APITypes.ApplyDocumentMappingMutation
>;
export const updateTenantLogo = /* GraphQL */ `mutation UpdateTenantLogo($input: UpdateTenantLogoInput) {
  updateTenantLogo(input: $input)
}
` as GeneratedMutation<
  APITypes.UpdateTenantLogoMutationVariables,
  APITypes.UpdateTenantLogoMutation
>;
export const lockCustomDeck = /* GraphQL */ `mutation LockCustomDeck(
  $customDeckId: String!
  $timestarted: String!
  $lock: Boolean!
) {
  lockCustomDeck(
    customDeckId: $customDeckId
    timestarted: $timestarted
    lock: $lock
  ) {
    id
    createdAt
    createdBy
    autoUpdateAcknowledgedAt
    updatedAt
    updatedBy
    tenantId
    groups {
      id
      pages {
        pageId
        pageNumber
        documentVersionId
        __typename
      }
      visible
      srcId
      docAccessLevel
      name
      locked
      __typename
    }
    title
    editMutex {
      userId
      timeStarted
      lastSeenAt
      __typename
    }
    sourceCustomDeckId
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.LockCustomDeckMutationVariables,
  APITypes.LockCustomDeckMutation
>;
export const updateZendeskOrg = /* GraphQL */ `mutation UpdateZendeskOrg($input: UpdateZendeskOrgInput!) {
  updateZendeskOrg(input: $input)
}
` as GeneratedMutation<
  APITypes.UpdateZendeskOrgMutationVariables,
  APITypes.UpdateZendeskOrgMutation
>;
export const publishDocument = /* GraphQL */ `mutation PublishDocument($documentId: String!) {
  publishDocument(documentId: $documentId) {
    id
    tenantId
    documentId
    versionNumber
    srcFilename
    contentURL
    conversionStatus
    status
    srcFile {
      bucket
      region
      key
      url
      __typename
    }
    srcHash
    srcSize
    numPages
    pageSettings {
      pageId
      number
      isRequired
      isHidden
      sourceIsHidden
      linkedSlides
      __typename
    }
    pageGroups {
      id
      pageIds
      name
      locked
      sourceID
      source
      __typename
    }
    type
    releaseNotes
    changeType
    labelValues {
      key
      value
      __typename
    }
    customValues {
      fieldId
      objectRecords {
        id
        externalId
        syncStatus
        status
        values {
          fieldId
          values
          __typename
        }
        __typename
      }
      values
      __typename
    }
    aiGeneratedLabels {
      categoryKey
      categoryLabel
      value
      normalizedValue
      modelId
      confidence
      evidence
      generatedAt
      __typename
    }
    title
    shortDescription
    shortSummary
    longDescription
    owner
    expiresAt
    hasCopyright
    hasCustomThumbnail
    purpose
    canHideSlides
    distributable
    downloadable
    isInternalGenerated
    semVer {
      minor
      major
      __typename
    }
    notificationScope
    syncScope
    selectedThumbnail
    publishedAt
    uploadedAt
    uploadedBy
    convertedArchiveKey
    convertedArchiveSize
    convertedFolderKey
    associatedFiles {
      id
      isDistributable
      isDefault
      type
      attachmentId
      status
      createdAt
      createdBy
      __typename
    }
    editPermissions
    converterVersion
    createdAt
    createdBy
    updatedAt
    updatedBy
    integration {
      externalVersionId
      version
      timestamp
      srcFileHash
      srcMappedMetadataHash
      __typename
    }
    integrationType
    conversionWarningCode
    conversionErrorCode
    scheduledPublish
    mappingStatus
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.PublishDocumentMutationVariables,
  APITypes.PublishDocumentMutation
>;
export const deleteAllDocumentVersions = /* GraphQL */ `mutation DeleteAllDocumentVersions($documentId: ID!) {
  deleteAllDocumentVersions(documentId: $documentId)
}
` as GeneratedMutation<
  APITypes.DeleteAllDocumentVersionsMutationVariables,
  APITypes.DeleteAllDocumentVersionsMutation
>;
export const updateDocumentPageData = /* GraphQL */ `mutation UpdateDocumentPageData($input: UpdateJsonPagesLambdaInput!) {
  updateDocumentPageData(input: $input)
}
` as GeneratedMutation<
  APITypes.UpdateDocumentPageDataMutationVariables,
  APITypes.UpdateDocumentPageDataMutation
>;
export const generateDownloadKey = /* GraphQL */ `mutation GenerateDownloadKey(
  $token: ID!
  $contentId: ID
  $contentType: ASSOCIATED_FILE_TYPE
) {
  generateDownloadKey(
    token: $token
    contentId: $contentId
    contentType: $contentType
  )
}
` as GeneratedMutation<
  APITypes.GenerateDownloadKeyMutationVariables,
  APITypes.GenerateDownloadKeyMutation
>;
export const generateDownloadKeyByTenant = /* GraphQL */ `mutation GenerateDownloadKeyByTenant(
  $hubId: ID!
  $contentId: ID
  $contentType: ASSOCIATED_FILE_TYPE
) {
  generateDownloadKeyByTenant(
    hubId: $hubId
    contentId: $contentId
    contentType: $contentType
  )
}
` as GeneratedMutation<
  APITypes.GenerateDownloadKeyByTenantMutationVariables,
  APITypes.GenerateDownloadKeyByTenantMutation
>;
export const pushAnalytics = /* GraphQL */ `mutation PushAnalytics($input: AWSJSON!, $userToken: String) {
  pushAnalytics(input: $input, userToken: $userToken)
}
` as GeneratedMutation<
  APITypes.PushAnalyticsMutationVariables,
  APITypes.PushAnalyticsMutation
>;
export const quoteMantleDocumentSummaryDebug = /* GraphQL */ `mutation QuoteMantleDocumentSummaryDebug(
  $documentVersionId: ID!
  $modelId: String!
  $systemPrompt: String
) {
  quoteMantleDocumentSummaryDebug(
    documentVersionId: $documentVersionId
    modelId: $modelId
    systemPrompt: $systemPrompt
  ) {
    documentVersionId
    previousDocumentVersionId
    previousDocumentVersionNumber
    modelId
    quoteToken
    inputPriceUsdPer1MTokens
    outputPriceUsdPer1MTokens
    priceAvailable
    estimatedInputTokens
    maxOutputTokens
    estimatedMaxCostUsd
    __typename
  }
}
` as GeneratedMutation<
  APITypes.QuoteMantleDocumentSummaryDebugMutationVariables,
  APITypes.QuoteMantleDocumentSummaryDebugMutation
>;
export const generateMantleDocumentSummaryDebug = /* GraphQL */ `mutation GenerateMantleDocumentSummaryDebug(
  $documentVersionId: ID!
  $modelId: String!
  $quoteToken: String!
  $systemPrompt: String
) {
  generateMantleDocumentSummaryDebug(
    documentVersionId: $documentVersionId
    modelId: $modelId
    quoteToken: $quoteToken
    systemPrompt: $systemPrompt
  ) {
    documentVersionId
    previousDocumentVersionId
    previousDocumentVersionNumber
    modelId
    summary
    inputTokens
    outputTokens
    inputPriceUsdPer1MTokens
    outputPriceUsdPer1MTokens
    priceAvailable
    actualCostUsd
    __typename
  }
}
` as GeneratedMutation<
  APITypes.GenerateMantleDocumentSummaryDebugMutationVariables,
  APITypes.GenerateMantleDocumentSummaryDebugMutation
>;
export const saveMantleDocumentSummaryDebug = /* GraphQL */ `mutation SaveMantleDocumentSummaryDebug(
  $documentVersionId: ID!
  $summary: String!
) {
  saveMantleDocumentSummaryDebug(
    documentVersionId: $documentVersionId
    summary: $summary
  ) {
    saved
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SaveMantleDocumentSummaryDebugMutationVariables,
  APITypes.SaveMantleDocumentSummaryDebugMutation
>;
export const pushLogs = /* GraphQL */ `mutation PushLogs($input: [String!]!, $shouldSendEmail: Boolean) {
  pushLogs(input: $input, shouldSendEmail: $shouldSendEmail)
}
` as GeneratedMutation<
  APITypes.PushLogsMutationVariables,
  APITypes.PushLogsMutation
>;
export const getLatestDocumentVersionId = /* GraphQL */ `mutation GetLatestDocumentVersionId($input: AWSJSON!) {
  getLatestDocumentVersionId(input: $input)
}
` as GeneratedMutation<
  APITypes.GetLatestDocumentVersionIdMutationVariables,
  APITypes.GetLatestDocumentVersionIdMutation
>;
export const submitTenantForm = /* GraphQL */ `mutation SubmitTenantForm($formId: ID!, $customValues: [CustomValuesInput!]) {
  submitTenantForm(formId: $formId, customValues: $customValues)
}
` as GeneratedMutation<
  APITypes.SubmitTenantFormMutationVariables,
  APITypes.SubmitTenantFormMutation
>;
export const updateFolderSharePermissions = /* GraphQL */ `mutation UpdateFolderSharePermissions(
  $folderId: ID!
  $sharePermissions: [SharePermissionInput!]
  $sendEmailNotification: Boolean
) {
  updateFolderSharePermissions(
    folderId: $folderId
    sharePermissions: $sharePermissions
    sendEmailNotification: $sendEmailNotification
  ) {
    id
    tenantId
    name
    isPinned
    status
    items {
      id
      type
      itemId
      status
      addedAt
      updateAcknowledgedAt
      itemLastUpdatedAt
      visiblePages
      customTitle
      __typename
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
    sharePermissions {
      id
      isDeleted
      type
      targetType
      targetUsername
      targetCustomValues {
        fieldId
        objectRecords {
          id
          externalId
          syncStatus
          status
          values {
            fieldId
            values
            __typename
          }
          __typename
        }
        values
        __typename
      }
      targetLabels {
        key
        values
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      deletedBy
      deletedAt
      __typename
    }
    shareStatus
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFolderSharePermissionsMutationVariables,
  APITypes.UpdateFolderSharePermissionsMutation
>;
export const updateFolderItems = /* GraphQL */ `mutation UpdateFolderItems(
  $foldersUpdates: [UpdateFolderInput!]!
  $rootFolderId: String
) {
  updateFolderItems(
    foldersUpdates: $foldersUpdates
    rootFolderId: $rootFolderId
  ) {
    id
    tenantId
    name
    isPinned
    status
    items {
      id
      type
      itemId
      status
      addedAt
      updateAcknowledgedAt
      itemLastUpdatedAt
      visiblePages
      customTitle
      __typename
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
    sharePermissions {
      id
      isDeleted
      type
      targetType
      targetUsername
      targetCustomValues {
        fieldId
        objectRecords {
          id
          externalId
          syncStatus
          status
          values {
            fieldId
            values
            __typename
          }
          __typename
        }
        values
        __typename
      }
      targetLabels {
        key
        values
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      deletedBy
      deletedAt
      __typename
    }
    shareStatus
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFolderItemsMutationVariables,
  APITypes.UpdateFolderItemsMutation
>;
export const createSubFolder = /* GraphQL */ `mutation CreateSubFolder($newSubFolder: CreateSubFolderInput!) {
  createSubFolder(newSubFolder: $newSubFolder) {
    id
    tenantId
    name
    isPinned
    status
    items {
      id
      type
      itemId
      status
      addedAt
      updateAcknowledgedAt
      itemLastUpdatedAt
      visiblePages
      customTitle
      __typename
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
    sharePermissions {
      id
      isDeleted
      type
      targetType
      targetUsername
      targetCustomValues {
        fieldId
        objectRecords {
          id
          externalId
          syncStatus
          status
          values {
            fieldId
            values
            __typename
          }
          __typename
        }
        values
        __typename
      }
      targetLabels {
        key
        values
        __typename
      }
      createdAt
      createdBy
      updatedAt
      updatedBy
      deletedBy
      deletedAt
      __typename
    }
    shareStatus
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSubFolderMutationVariables,
  APITypes.CreateSubFolderMutation
>;
export const upsertVersionContents = /* GraphQL */ `mutation UpsertVersionContents(
  $documentVersionId: ID!
  $tenantId: ID!
  $configName: String
) {
  upsertVersionContents(
    documentVersionId: $documentVersionId
    tenantId: $tenantId
    configName: $configName
  ) {
    documentVersionId
    tenantId
    result
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpsertVersionContentsMutationVariables,
  APITypes.UpsertVersionContentsMutation
>;
export const updateDocVerPageMatches = /* GraphQL */ `mutation UpdateDocVerPageMatches($docVerId: ID!) {
  updateDocVerPageMatches(docVerId: $docVerId) {
    tenantId
    documentVersionId
    status
    message
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDocVerPageMatchesMutationVariables,
  APITypes.UpdateDocVerPageMatchesMutation
>;
export const startAthenaQueryExecutionMeetingReport = /* GraphQL */ `mutation StartAthenaQueryExecutionMeetingReport(
  $startDate: String!
  $endDate: String
) {
  startAthenaQueryExecutionMeetingReport(
    startDate: $startDate
    endDate: $endDate
  )
}
` as GeneratedMutation<
  APITypes.StartAthenaQueryExecutionMeetingReportMutationVariables,
  APITypes.StartAthenaQueryExecutionMeetingReportMutation
>;
export const notifyCsvExportReady = /* GraphQL */ `mutation NotifyCsvExportReady(
  $userId: ID!
  $signedUrl: String!
  $queryExecutionId: String!
) {
  notifyCsvExportReady(
    userId: $userId
    signedUrl: $signedUrl
    queryExecutionId: $queryExecutionId
  ) {
    userId
    signedUrl
    queryExecutionId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.NotifyCsvExportReadyMutationVariables,
  APITypes.NotifyCsvExportReadyMutation
>;
export const executeLangflow = /* GraphQL */ `mutation ExecuteLangflow($input: ExecuteLangflowInput!) {
  executeLangflow(input: $input)
}
` as GeneratedMutation<
  APITypes.ExecuteLangflowMutationVariables,
  APITypes.ExecuteLangflowMutation
>;
export const notifyLangflowResponse = /* GraphQL */ `mutation NotifyLangflowResponse(
  $tenantId: ID!
  $userId: ID!
  $sessionId: String!
  $status: LangflowStatus!
  $statusDetail: String
  $response: String
  $metadata: AWSJSON
) {
  notifyLangflowResponse(
    tenantId: $tenantId
    userId: $userId
    sessionId: $sessionId
    status: $status
    statusDetail: $statusDetail
    response: $response
    metadata: $metadata
  ) {
    tenantId
    userId
    sessionId
    status
    statusDetail
    response
    metadata
    __typename
  }
}
` as GeneratedMutation<
  APITypes.NotifyLangflowResponseMutationVariables,
  APITypes.NotifyLangflowResponseMutation
>;
export const loginVeevaVault = /* GraphQL */ `mutation LoginVeevaVault($input: VeevaVaultLoginInput!) {
  loginVeevaVault(input: $input) {
    encryptedSessionId
    sessionIdIssuanceDatetime
    maximumInactiveSessionDurationInSeconds
    userInfo {
      id
      email
      username
      firstName
      lastName
      displayName
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.LoginVeevaVaultMutationVariables,
  APITypes.LoginVeevaVaultMutation
>;
export const exchangeExternalOidcVaultCrmSsoToken = /* GraphQL */ `mutation ExchangeExternalOidcVaultCrmSsoToken(
  $input: ExternalOidcVaultCrmSsoExchangeInput!
) {
  exchangeExternalOidcVaultCrmSsoToken(input: $input) {
    encryptedSessionId
    sessionIdIssuanceDatetime
    maximumInactiveSessionDurationInSeconds
    userInfo {
      id
      email
      username
      firstName
      lastName
      displayName
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ExchangeExternalOidcVaultCrmSsoTokenMutationVariables,
  APITypes.ExchangeExternalOidcVaultCrmSsoTokenMutation
>;
export const keepVeevaVaultSessionAlive = /* GraphQL */ `mutation KeepVeevaVaultSessionAlive($encryptedSessionId: String!) {
  keepVeevaVaultSessionAlive(encryptedSessionId: $encryptedSessionId)
}
` as GeneratedMutation<
  APITypes.KeepVeevaVaultSessionAliveMutationVariables,
  APITypes.KeepVeevaVaultSessionAliveMutation
>;
export const endVeevaVaultSession = /* GraphQL */ `mutation EndVeevaVaultSession($encryptedSessionId: String!) {
  endVeevaVaultSession(encryptedSessionId: $encryptedSessionId)
}
` as GeneratedMutation<
  APITypes.EndVeevaVaultSessionMutationVariables,
  APITypes.EndVeevaVaultSessionMutation
>;
export const upsertVeevaVaultObjects = /* GraphQL */ `mutation UpsertVeevaVaultObjects($input: VeevaVaultUpsertObjectsInput!) {
  upsertVeevaVaultObjects(input: $input) {
    response
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpsertVeevaVaultObjectsMutationVariables,
  APITypes.UpsertVeevaVaultObjectsMutation
>;
export const deleteVeevaVaultObjects = /* GraphQL */ `mutation DeleteVeevaVaultObjects($input: VeevaVaultDeleteObjectsInput!) {
  deleteVeevaVaultObjects(input: $input) {
    response
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteVeevaVaultObjectsMutationVariables,
  APITypes.DeleteVeevaVaultObjectsMutation
>;
